export type TnLanguageCode = 'vi' | 'en' | 'zh';

export const TN_LANGUAGE_STORAGE_KEY = 'tuvan_nhathau.lang';
/** Tên setting lưu trên server (user_settings) - trùng với key localStorage để đồng bộ */
export const TN_LANGUAGE_SETTING_NAME = 'tuvan_nhathau.lang';

export const tnLanguageLabels: Record<TnLanguageCode, string> = {
  vi: 'Tiếng Việt',
  en: 'English',
  zh: '中文',
};

export const getCurrentTnLanguage = (): TnLanguageCode => {
  if (typeof window === 'undefined') {
    return 'vi';
  }
  const stored = window.localStorage.getItem(TN_LANGUAGE_STORAGE_KEY);
  if (stored === 'zh') return 'zh';
  if (stored === 'en') return 'en';
  return 'vi';
};

export const setCurrentTnLanguage = (lang: TnLanguageCode) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(TN_LANGUAGE_STORAGE_KEY, lang);
};

/** Lấy text theo lang, nếu không có bản zh thì fallback sang en rồi vi */
export function getTnText(obj: { vi?: string; en?: string; zh?: string } | undefined, lang: TnLanguageCode): string {
  if (!obj || typeof obj !== 'object') return '';
  const o = obj as Record<string, string | undefined>;
  return o[lang] ?? o.en ?? o.vi ?? '';
}

export const tnTexts = {
  topBar: {
    tabs: {
      dashboard: {
        vi: 'Dashboard',
        en: 'Dashboard',
        zh: '仪表板',
      },
    },
    searchPlaceholder: {
      vi: 'Tìm kiếm tài liệu...',
      en: 'Search documents...',
      zh: '搜索文档...',
    },
    userDefaultName: {
      vi: 'Nhà thầu/Tư vấn',
      en: 'Contractor / Consultant',
      zh: '承包商/咨询',
    },
    accountSettings: {
      vi: 'Cài đặt tài khoản',
      en: 'Account settings',
      zh: '账户设置',
    },
    projectSettings: {
      vi: 'Cài đặt',
      en: 'Settings',
      zh: '设置',
    },
    userGuide: {
      vi: 'Hướng dẫn',
      en: 'User guide',
      zh: '用户指南',
    },
    languageMenuTitle: {
      vi: 'Ngôn ngữ',
      en: 'Language',
      zh: '语言',
    },
    rolesTitle: {
      vi: 'Vai trò',
      en: 'Roles',
      zh: '角色',
    },
    logout: {
      vi: 'Đăng xuất',
      en: 'Sign out',
      zh: '退出登录',
    },
    featureComingSoon: {
      vi: 'Tính năng đang phát triển. Vui lòng quay lại sau.',
      en: 'This feature is under development. Please check back later.',
      zh: '功能开发中，请稍后再试。',
    },
    breakdownMenus: {
      fbsTitle: {
        vi: 'Công việc FBS',
        en: 'FBS Tasks',
        zh: 'FBS 任务',
      },
      fbsSubtitle: {
        vi: 'Functional Breakdown Structure',
        en: 'Functional Breakdown Structure',
        zh: '功能分解结构',
      },
      wbsTitle: {
        vi: 'Công việc WBS',
        en: 'WBS Tasks',
        zh: 'WBS 任务',
      },
      wbsSubtitle: {
        vi: 'Work Breakdown Structure',
        en: 'Work Breakdown Structure',
        zh: '工作分解结构',
      },
      uniclassTitle: {
        vi: 'UniClass',
        en: 'UniClass',
        zh: 'UniClass',
      },
      uniclassSubtitle: {
        vi: 'Hệ thống phân loại Uniclass',
        en: 'Uniclass classification system',
        zh: 'Uniclass 分类系统',
      },
    },
  },
  accessLog: {
    title: {
      vi: 'Nhật ký truy cập',
      en: 'Access log',
      zh: '访问日志',
    },
    subtitle: {
      vi: 'Giám sát và kiểm tra các hoạt động bảo mật của hệ thống.',
      en: 'Monitor and review security-related activities of the system.',
      zh: '监控和检查系统安全相关活动。',
    },
    exportReport: {
      vi: 'Xuất báo cáo',
      en: 'Export report',
      zh: '导出报告',
    },
    fromDate: {
      vi: 'Từ ngày',
      en: 'From date',
      zh: '开始日期',
    },
    toDate: {
      vi: 'Đến ngày',
      en: 'To date',
      zh: '结束日期',
    },
    staffLabel: {
        vi: 'Nhân viên',
        en: 'Staff',
        zh: '员工',
    },
    allStaff: {
      vi: 'Tất cả nhân viên',
      en: 'All staff',
      zh: '全部员工',
    },
    actionTypeLabel: {
      vi: 'Loại hành động',
      en: 'Action type',
      zh: '操作类型',
    },
    allActions: {
      vi: 'Tất cả hành động',
      en: 'All actions',
      zh: '全部操作',
    },
    filterButton: {
      vi: 'Lọc kết quả',
      en: 'Filter results',
      zh: '筛选结果',
    },
    columns: {
      time: {
        vi: 'Thời gian',
        en: 'Time',
        zh: '时间',
      },
      username: {
        vi: 'Tên người dùng',
        en: 'Username',
        zh: '用户名',
      },
      action: {
        vi: 'Hành động',
        en: 'Action',
        zh: '操作',
      },
      target: {
        vi: 'Đối tượng tác động',
        en: 'Target object',
        zh: '目标对象',
      },
      ipAddress: {
        vi: 'Địa chỉ IP',
        en: 'IP address',
        zh: 'IP 地址',
      },
      device: {
        vi: 'Thiết bị',
        en: 'Device',
        zh: '设备',
      },
    },
    tableDatas: {
      action: {
        login: {
          vi: 'Đăng nhập',
          en: 'Login',
          zh: '登录',
        },
        logout: {
          vi: 'Đăng xuất',
          en: 'Logout',
          zh: '登出',
        },
        to_fa: {
          vi: 'Xác thực 2 bước',
          en: 'Two-factor authentication',
          zh: '双因素认证',
        },
        create_document: {
          vi: 'Tạo văn bản',
          en: 'Create document',
          zh: '创建文档',
        },
        document_approval: {
          vi: 'Phê duyệt văn bản',
          en: 'Document approval',
          zh: '文档审批',
        },
        send_document: {
          vi: 'Gửi văn bản',
          en: 'Send document',
          zh: '发送文档',
        },
        submited_to_department_head: {
          vi: 'Trình trưởng đơn vị',
          en: 'Submitted to department head',
          zh: '已提交部门负责人',
        },
        submitted_to_unit_leadership: {
          vi: 'Trình lãnh đạo ban',
          en: 'Submitted to unit leadership',
          zh: '已提交单位领导',
        },
        submited_to_division_leadership: {
          vi: 'Trình trưởng bộ phận',
          en: 'Submitted to division leadership',
          zh: '已提交部门领导',
        },
        publiced_document: {
          vi: 'Ban hành văn bản',
          en: 'Published document',
          zh: '发布文档',
        },
        deleted_document: {
          vi: 'Xóa văn bản',
          en: 'Deleted document',
          zh: '删除文档',
        },
      },
    },
    loading: {
      vi: 'Đang tải...',
      en: 'Loading...',
      zh: '加载中...',
    },
    empty: {
      vi: 'Không có dữ liệu',
      en: 'No data',
      zh: '暂无数据',
    },
    paginationSummary: {
      vi: (from: number, to: number, total: number) =>
        `Hiển thị ${from}-${to} trong tổng số ${total} hoạt động`,
      en: (from: number, to: number, total: number) =>
        `Showing ${from}-${to} of ${total} activities`,
      zh: (from: number, to: number, total: number) =>
        `显示第 ${from}-${to} 条，共 ${total} 条活动`,
    },
  },
  incomingDetail: {
    previewNotice: {
      vi: 'Đây là bản xem trước. Bạn cần nhờ văn thư chuyển cho bạn văn bản này để có thể xử lý tiếp văn bản này.',
      en: 'This is a preview. Please ask the clerk to assign this document to you so you can continue processing it.',
      zh: '此为预览。请让文书将此文档分配给您以便继续处理。',
    },
    headerTitle: {
      vi: 'Chi tiết văn bản đến',
      en: 'Incoming document detail',
      zh: '来文详情',
    },
    codeLabel: {
      vi: 'Mã hồ sơ',
      en: 'Record code',
      zh: '档案编号',
    },
    viewer: {
      iframeTitle: {
        vi: 'Xem trước',
        en: 'Preview',
        zh: '预览',
      },
      onlyPdfMessage: {
        vi: 'Chỉ hỗ trợ xem trước file PDF. Vui lòng tải xuống để xem.',
        en: 'Only PDF preview is supported. Please download the file to view it.',
        zh: '仅支持 PDF 预览，请下载后查看。',
      },
      emptyMessage: {
        vi: 'Nội dung văn bản sẽ hiển thị tại đây',
        en: 'Document content will be shown here',
        zh: '文档内容将显示在此处',
      },
    },
    fields: {
      id: {
        vi: 'ID văn bản',
        en: 'Document ID',
        zh: '文档 ID',
      },
      documentCode: {
        vi: 'Số hiệu',
        en: 'Number',
        zh: '文号',
      },
      incomingNumber: {
        vi: 'Số đến',
        en: 'Incoming number',
        zh: '收文编号',
      },
      documentDate: {
        vi: 'Ngày văn bản',
        en: 'Document date',
        zh: '发文日期',
      },
      receivedDate: {
        vi: 'Ngày đến',
        en: 'Received date',
        zh: '收文日期',
      },
      sender: {
        vi: 'Đơn vị gửi',
        en: 'Sender',
        zh: '发文单位',
      },
      title: {
        vi: 'Trích yếu nội dung',
        en: 'Summary',
        zh: '内容摘要',
      },
      deadline: {
        vi: 'Hạn xử lý',
        en: 'Processing deadline',
        zh: '处理期限',
      },
      description: {
        vi: 'Mô tả',
        en: 'Description',
        zh: '描述',
      },
      priority: {
        vi: 'Độ khẩn',
        en: 'Priority',
        zh: '紧急程度',
      },
    },
    sections: {
      detail: {
        vi: 'Thông tin chi tiết',
        en: 'Detail information',
        zh: '详细信息',
      },
      attachments: {
        vi: 'Tài liệu đính kèm',
        en: 'Attachments',
        zh: '附件',
      },
      history: {
        vi: 'Lịch sử xử lý',
        en: 'Processing history',
        zh: '处理历史',
      },
      processing: {
        vi: 'Xử lý văn bản',
        en: 'Process document',
        zh: '处理文档',
      },
    },
    attachments: {
      none: {
        vi: 'Chưa có tài liệu đính kèm',
        en: 'No attachments',
        zh: '暂无附件',
      },
      downloadTitle: {
        vi: 'Tải xuống',
        en: 'Download',
        zh: '下载',
      },
    },
    history: {
      none: {
        vi: 'Chưa có lịch sử xử lý',
        en: 'No processing history',
        zh: '暂无处理历史',
      },
      seeAll: {
        vi: 'Xem tất cả',
        en: 'View all',
        zh: '查看全部',
      },
      modalTitle: {
        vi: 'Lịch sử xử lý',
        en: 'Processing history',
        zh: '处理历史',
      },
      actions: {
        xem_chitiet: {
          vi: 'Xem chi tiết',
          en: 'View detail',
          zh: '查看详情',
        },
        trinh_ld_bophan: {
          vi: 'Trình lãnh đạo bộ phận',
          en: 'Submit to department leader',
          zh: '提交部门领导',
        },
        trinh_ld_donvi: {
          vi: 'Trình lãnh đạo đơn vị',
          en: 'Submit to unit leader',
          zh: '提交单位领导',
        },
        chuyen_xu_ly: {
          vi: 'Chuyển xử lý',
          en: 'Forward for processing',
          zh: '转办',
        },
        tralai: {
          vi: 'Trả lại',
          en: 'Return',
          zh: '退回',
        },
        xuly_phoihop: {
          vi: 'Xử lý phối hợp',
          en: 'Co-processing',
          zh: '协办',
        },
        xem_de_biet: {
          vi: 'Xem để biết',
          en: 'For information',
          zh: '阅知',
        },
        hoan_thanh: {
          vi: 'Hoàn thành',
          en: 'Completed',
          zh: '已完成',
        },
      },
    },
    processing: {
      commentLabel: {
        vi: 'Ý kiến xử lý / Phản hồi',
        en: 'Processing opinion / Feedback',
        zh: '处理意见 / 反馈',
      },
      commentPlaceholder: {
        vi: 'Nhập ý kiến chỉ đạo hoặc nội dung phản hồi...',
        en: 'Enter instructions or feedback...',
        zh: '输入批示或反馈内容...',
      },
    },
    footerButtons: {
      back: {
        vi: 'Quay lại',
        en: 'Back',
        zh: '返回',
      },
      forwardViewOnly: {
        vi: 'Chuyển xem để biết',
        en: 'Forward for information',
        zh: '转阅知',
      },
      newEntry: {
        vi: 'Nhập mới',
        en: 'Create',
        zh: '新建',
      },
      forwardDeptLeader: {
        vi: 'Trình LĐ bộ phận',
        en: 'Submit to department leader',
        zh: '提交部门领导',
      },
      forwardUnitLeader: {
        vi: 'Trình LĐ đơn vị',
        en: 'Submit to unit leader',
        zh: '提交单位领导',
      },
      forwardNext: {
        vi: 'Chuyển xử lý tiếp',
        en: 'Forward for further processing',
        zh: '转下一步处理',
      },
      complete: {
        vi: 'Hoàn thành',
        en: 'Complete',
        zh: '完成',
      },
    },
    dialogs: {
      trinhLdBophanTitle: {
        vi: 'Trình lãnh đạo bộ phận',
        en: 'Submit to department leader',
        zh: '提交部门领导',
      },
      trinhLdDonviTitle: {
        vi: 'Trình lãnh đạo đơn vị',
        en: 'Submit to unit leader',
        zh: '提交单位领导',
      },
      chuyenXuLyTitle: {
        vi: 'Chuyển xử lý tiếp',
        en: 'Forward for further processing',
        zh: '转下一步处理',
      },
      chuyenXemDeBietTitle: {
        vi: 'Chuyển xem để biết',
        en: 'Forward for information',
        zh: '转阅知',
      },
      hoanThanhTitle: {
        vi: 'Hoàn thành xử lý',
        en: 'Mark as completed',
        zh: '标记为已完成',
      },
      nhapMoiTitle: {
        vi: 'Nhập mới – Chỉnh sửa văn bản (giống tạo mới dự thảo)',
        en: 'New entry – Edit document (same as creating draft)',
        zh: '新建 – 编辑文档（同创建草稿）',
      },
      noteLabel: {
        vi: 'Ghi chú',
        en: 'Note',
        zh: '备注',
      },
      notePlaceholder: {
        vi: 'Nhập ghi chú (không bắt buộc)',
        en: 'Enter note (optional)',
        zh: '输入备注（可选）',
      },
      cancel: {
        vi: 'Hủy',
        en: 'Cancel',
        zh: '取消',
      },
      close: {
        vi: 'Đóng',
        en: 'Close',
        zh: '关闭',
      },
      submit: {
        vi: 'Trình',
        en: 'Submit',
        zh: '提交',
      },
      transfer: {
        vi: 'Chuyển',
        en: 'Forward',
        zh: '转发',
      },
      searchPlaceholder: {
        vi: 'Chọn hoặc gõ tìm...',
        en: 'Select or type to search...',
        zh: '选择或输入搜索...',
      },
      saving: {
        vi: 'Đang lưu...',
        en: 'Saving...',
        zh: '保存中...',
      },
    },
    form: {
      groupLabel: {
        vi: 'Nhóm văn bản (sổ)',
        en: 'Document group (registry)',
        zh: '文档组（登记簿）',
      },
      groupPlaceholder: {
        vi: 'Chọn sổ',
        en: 'Select registry',
        zh: '选择登记簿',
      },
      incomingNumberLabel: {
        vi: 'Số đến',
        en: 'Incoming number',
        zh: '收文编号',
      },
      incomingNumberPlaceholder: {
        vi: 'Tự nhảy khi chọn sổ',
        en: 'Auto generated when registry is selected',
        zh: '选择登记簿后自动生成',
      },
      documentCodeLabel: {
        vi: 'Số ký hiệu',
        en: 'Doc Num',
        zh: '文号',
      },
      documentCodePlaceholder: {
        vi: 'VD: CV-245/MRB-PMU3',
        en: 'E.g. CV-245/MRB-PMU3',
        zh: '例如：CV-245/MRB-PMU3',
      },
      titleLabel: {
        vi: 'Trích yếu',
        en: 'Summary',
        zh: '摘要',
      },
      titlePlaceholder: {
        vi: 'Tiêu đề / trích yếu văn bản',
        en: 'Document title / summary',
        zh: '文档标题 / 摘要',
      },
      documentDateLabel: {
        vi: 'Ngày văn bản',
        en: 'Document date',
        zh: '发文日期',
      },
      receivedDateLabel: {
        vi: 'Ngày đến',
        en: 'Received date',
        zh: '收文日期',
      },
      senderLabel: {
        vi: 'Nơi gửi',
        en: 'Sender',
        zh: '发文单位',
      },
      senderPlaceholder: {
        vi: 'VD: MRB',
        en: 'E.g. MRB',
        zh: '例如：MRB',
      },
      priorityLabel: {
        vi: 'Độ ưu tiên',
        en: 'Priority',
        zh: '优先级',
      },
      deadlineLabel: {
        vi: 'Hạn xử lý',
        en: 'Processing deadline',
        zh: '处理期限',
      },
      descriptionLabel: {
        vi: 'Mô tả',
        en: 'Description',
        zh: '描述',
      },
      descriptionPlaceholder: {
        vi: 'Mô tả ngắn',
        en: 'Short description',
        zh: '简短描述',
      },
      attachmentsLabel: {
        vi: 'File đính kèm',
        en: 'Attachments',
        zh: '附件',
      },
      attachmentsRequiredHint: {
        vi: '(bắt buộc ít nhất 1 file)',
        en: '(at least 1 file is required)',
        zh: '（至少需要 1 个文件）',
      },
      selectAttachmentButton: {
        vi: 'Chọn file đính kèm',
        en: 'Select attachment files',
        zh: '选择附件',
      },
      deleteFileTitle: {
        vi: 'Xóa file',
        en: 'Remove file',
        zh: '删除文件',
      },
      notSelectedOption: {
        vi: 'Không chọn',
        en: 'Not selected',
        zh: '不选择',
      },
      docsCatalogLabel: {
        vi: 'Loại văn bản',
        en: 'Document type',
        zh: '文档类型',
      },
      docsCatalogPlaceholder: {
        vi: 'Không chọn',
        en: 'Not selected',
        zh: '不选择',
      },
      saveButton: {
        vi: 'Lưu',
        en: 'Save',
        zh: '保存',
      },
    },
    priority: {
      khan: {
        vi: 'Khẩn',
        en: 'Urgent',
        zh: '紧急',
      },
      hoaToc: {
        vi: 'Hỏa tốc',
        en: 'Express',
        zh: '特急',
      },
      thap: {
        vi: 'Thấp',
        en: 'Low',
        zh: '低',
      },
      thuong: {
        vi: 'Thường',
        en: 'Normal',
        zh: '普通',
      },
    },
    messages: {
      fetchError: {
        vi: 'Không tải được thông tin văn bản',
        en: 'Failed to load document information',
        zh: '加载文档信息失败',
      },
      genericError: {
        vi: 'Có lỗi xảy ra',
        en: 'An error occurred',
        zh: '发生错误',
      },
      invalidLink: {
        vi: 'Link không hợp lệ',
        en: 'Invalid link',
        zh: '链接无效',
      },
      notFound: {
        vi: 'Không tìm thấy văn bản',
        en: 'Document not found',
        zh: '未找到文档',
      },
      selectAtLeastOne: {
        vi: 'Chọn ít nhất 1 người (xử lý chính, phối hợp hoặc xem để biết)',
        en: 'Select at least one person (main handler, co-processor or for information)',
        zh: '请至少选择一人（主办、协办或阅知）',
      },
      selectAtLeastOneViewOnly: {
        vi: 'Chọn ít nhất 1 người xem để biết',
        en: 'Select at least one person for information',
        zh: '请至少选择一人阅知',
      },
      trinhLdBophanSuccess: {
        vi: 'Trình lãnh đạo bộ phận thành công',
        en: 'Submitted to department leader successfully',
        zh: '已成功提交部门领导',
      },
      trinhLdDonviSuccess: {
        vi: 'Trình lãnh đạo đơn vị thành công',
        en: 'Submitted to unit leader successfully',
        zh: '已成功提交单位领导',
      },
      chuyenXuLySuccess: {
        vi: 'Chuyển xử lý thành công',
        en: 'Forwarded for processing successfully',
        zh: '转办成功',
      },
      chuyenXemDeBietSuccess: {
        vi: 'Chuyển xem để biết thành công',
        en: 'Forwarded for information successfully',
        zh: '转阅知成功',
      },
      hoanThanhSuccess: {
        vi: 'Đã đánh dấu hoàn thành',
        en: 'Marked as completed',
        zh: '已标记为完成',
      },
      previewNoPermissionMain: {
        vi: 'Bạn không có quyền xem văn bản này. Chỉ văn thư đến tư vấn nhà thầu được xem văn bản này đầu tiên và cần chuyển xử lý cho bạn thì bạn mới có thể xử lý tiếp văn bản.',
        en: 'You do not have permission to view this document. Only the incoming clerk for contractor consulting can see this document first and must forward it to you before you can continue processing it.',
        zh: '您无权查看此文档。只有承包商咨询模块的收文文员可以首先查看此文档，并需将其转交给您之后，您才能继续处理该文档。',
      },
      previewQuestionBackHome: {
        vi: 'Bạn có muốn quay về trang chính không?',
        en: 'Do you want to go back to the main page?',
        zh: '您是否要返回主页？',
      },
      previewModalTitleNotFound: {
        vi: 'Không tìm thấy văn bản',
        en: 'Document not found',
        zh: '未找到文档',
      },
      previewModalTitleError: {
        vi: 'Lỗi hệ thống',
        en: 'System error',
        zh: '系统错误',
      },
      previewModalTitleNoPermission: {
        vi: 'Không có quyền xem',
        en: 'No permission',
        zh: '无权查看',
      },
      previewStayButton: {
        vi: 'Ở lại',
        en: 'Stay',
        zh: '留在此页',
      },
      previewGoHomeButton: {
        vi: 'Quay về trang chính',
        en: 'Main page',
        zh: '返回主页',
      },
    },
  },
  outgoing: {
    common: {
      stepperLabels: {
        vi: ['1. Khởi tạo', '2. Xem xét', '3. Phê duyệt', '4. Ký số và gửi'],
        en: ['1. Draft', '2. Review', '3. Approve', '4. Sign & send'],
        zh: ['1. 草稿', '2. 审阅', '3. 批准', '4. 签章并发送'],
      },
      generalInfoTitle: {
        vi: 'Thông tin chung',
        en: 'General information',
        zh: '基本信息',
      },
      issueInfoTitle: {
        vi: 'Thông tin ban hành',
        en: 'Issuance information',
        zh: '发文信息',
      },
      signatureVerifyTitle: {
        vi: 'Xác thực ký số & Phát hành',
        en: 'Digital signature & issuance',
        zh: '数字签名与发布',
      },
      attachmentListTitle: {
        vi: 'Danh sách file đính kèm',
        en: 'Attachments list',
        zh: '附件列表',
      },
      actionsNeededTitle: {
        vi: 'Hành động cần thực hiện',
        en: 'Required actions',
        zh: '待执行操作',
      },
      viewersTitle: {
        vi: 'Người được xem / Luân chuyển',
        en: 'Viewers / circulation',
        zh: '阅知/传阅',
      },
      logTitle: {
        vi: 'Log xử lý',
        en: 'Processing log',
        zh: '处理日志',
      },
      reviewSectionTitle: {
        vi: 'Ý kiến xem xét / Phê duyệt',
        en: 'Review / approval comments',
        zh: '审阅/审批意见',
      },
      attachmentsCardTitle: {
        vi: 'Tài liệu đính kèm',
        en: 'Attached documents',
        zh: '附件',
      },
      approvalFlowTitle: {
        vi: 'Luồng phê duyệt dự kiến',
        en: 'Expected approval workflow',
        zh: '预期审批流程',
      },
      infoNoteTitle: {
        vi: 'Lưu ý',
        en: 'Note',
        zh: '备注',
      },
      infoNoteContent: {
        vi: 'Vui lòng kiểm tra kỹ trích yếu và tệp đính kèm trước khi gửi Trưởng bộ phận duyệt. Sau khi gửi, bạn không thể chỉnh sửa cho đến khi có phản hồi từ cấp phê duyệt.',
        en: 'Please carefully verify the summary and attachments before submitting to the department leader. After submission, you cannot edit until there is feedback from the approver.',
        zh: '提交部门领导前请仔细核对摘要与附件。提交后在有审批反馈前无法编辑。',
      },
      twoFA: {
        useGoogleAuthTitle: {
          vi: 'Sử dụng Google Auth',
          en: 'Use Google Auth',
          zh: '使用 Google 认证',
        },
        deviceInfoFixed: {
          vi: 'Thiết bị: iPhone 15 Pro (Đang hoạt động)',
          en: 'Device: iPhone 15 Pro (Active)',
          zh: '设备：iPhone 15 Pro（使用中）',
        },
        changeButton: {
          vi: 'Thay đổi',
          en: 'Change',
          zh: '更换',
        },
        otpLabel: {
          vi: 'Mã OTP xác thực',
          en: 'OTP verification code',
          zh: 'OTP 验证码',
        },
        otpPlaceholder: {
          vi: 'Nhập mã 6 chữ số',
          en: 'Enter 6-digit code',
          zh: '输入 6 位验证码',
        },
      },
      fields: {
        id: {
          vi: 'ID văn bản',
          en: 'Document ID',
          zh: '文档 ID',
        },
        externalReceiver: {
          vi: 'Nơi nhận đơn vị bên ngoài',
          en: 'External receiving unit',
          zh: '外部收文单位',
        },
        submitDate: {
          vi: 'Ngày trình',
          en: 'Submit date',
          zh: '提交日期',
        },
        summary: {
          vi: 'Trích yếu',
          en: 'Summary',
          zh: '摘要',
        },
        documentCode: {
          vi: 'Số ký hiệu',
          en: 'Doc Num',
          zh: '文号',
        },
        documentNumber: {
          vi: 'Số văn bản',
          en: 'Document no.',
          zh: '文档编号',
        },
        catalogName: {
          vi: 'Loại công văn',
          en: 'Document type',
          zh: '公文类型',
        },
        issuingUnit: {
          vi: 'Đơn vị ban hành',
          en: 'Issuing unit',
          zh: '发文单位',
        },
        author: {
          vi: 'Người soạn thảo',
          en: 'Author',
          zh: '拟稿人',
        },
        expectedSigner: {
          vi: 'Người ký dự kiến',
          en: 'Expected signer',
          zh: '预期签发人',
        },
        dueDate: {
          vi: 'Hạn xử lý',
          en: 'Processing deadline',
          zh: '处理期限',
        },
        issueDocumentCode: {
          vi: 'Số ký hiệu',
          en: 'Doc Num',
          zh: '文号',
        },
        issueDate: {
          vi: 'Ngày ban hành',
          en: 'Issued date',
          zh: '发文日期',
        },
        status: {
          vi: 'Trạng thái',
          en: 'Status',
          zh: '状态',
        },
        securityLevel: {
          vi: 'Độ mật',
          en: 'Security level',
          zh: '密级',
        },
        priority: {
          vi: 'Độ khẩn',
          en: 'Priority',
          zh: '紧急程度',
        },
        description: {
          vi: 'Mô tả',
          en: 'Description',
          zh: '描述',
        },
        createdAt: {
          vi: 'Ngày tạo',
          en: 'Created at',
          zh: '创建时间',
        },
        updatedBy: {
          vi: 'Cập nhật',
          en: 'Updated by',
          zh: '更新人',
        },
        mainFileChip: {
          vi: 'File chính',
          en: 'Main file',
          zh: '主文件',
        },
        referenceFileChip: {
          vi: 'Đính kèm',
          en: 'Attachment',
          zh: '附件',
        },
      },
      viewers: {
        viewedAtPrefix: {
          vi: 'Đã xem:',
          en: 'Viewed at:',
          zh: '已阅：',
        },
        notViewedChip: {
          vi: 'Chưa xem',
          en: 'Not viewed',
          zh: '未阅',
        },
      },
      history: {
        emptyShort: {
          vi: 'Chưa có log xử lý.',
          en: 'No processing log yet.',
          zh: '暂无处理日志。',
        },
        expandButton: {
          vi: 'Mở rộng',
          en: 'Expand',
          zh: '展开',
        },
        modalTitle: {
          vi: 'Log xử lý',
          en: 'Processing log',
          zh: '处理日志',
        },
      },
      review: {
        leaderBophanLabel: {
          vi: 'Lãnh đạo bộ phận',
          en: 'Department leader',
          zh: '部门领导',
        },
        leaderDonviLabel: {
          vi: 'Lãnh đạo đơn vị',
          en: 'Unit leader',
          zh: '单位领导',
        },
        leaderBophanPlaceholder: {
          vi: '— Chọn lãnh đạo bộ phận —',
          en: '— Select department leader —',
          zh: '— 选择部门领导 —',
        },
        leaderDonviPlaceholder: {
          vi: '— Chọn lãnh đạo đơn vị —',
          en: '— Select unit leader —',
          zh: '— 选择单位领导 —',
        },
        vanThuDiLabel: {
          vi: 'Văn thư đi (Phê duyệt chuyển văn thư)',
          en: 'Outgoing clerk (Approve & forward to clerk)',
          zh: '发文文书（审批并转文书）',
        },
        reviewCommentLabel: {
          vi: 'Nội dung nhận xét / Ý kiến phê duyệt',
          en: 'Review / approval comments',
          zh: '审阅/审批意见',
        },
        reviewCommentPlaceholder: {
          vi: 'Nhập ý kiến xem xét hoặc yêu cầu sửa đổi tại đây...',
          en: 'Enter review comments or change requests here...',
          zh: '在此输入审阅意见或修改要求...',
        },
        saveTemplateLabel: {
          vi: 'Lưu vào danh sách ý kiến mẫu',
          en: 'Save as comment template',
          zh: '保存为意见模板',
        },
      },
      attachments: {
        none: {
          vi: 'Chưa có file đính kèm.',
          en: 'No attachments yet.',
          zh: '暂无附件。',
        },
        fileFallback: {
          vi: 'File đính kèm',
          en: 'Attachment',
          zh: '附件',
        },
        previewUnsupported: {
          vi: 'File "{name}" không hỗ trợ xem trước. Vui lòng tải xuống.',
          en: 'File "{name}" cannot be previewed. Please download it.',
          zh: '文件 "{name}" 无法预览，请下载查看。',
        },
        /** DOC/DOCX loại đính kèm (reference): không convert PDF, không xem trước trong app */
        referenceWordNoPreview: {
          vi: 'File đính kèm (reference) không hỗ trợ xem trước định dạng Word (.doc/.docx) trên hệ thống. Vui lòng tải xuống để mở trên máy.',
          en: 'Reference attachments do not support in-browser preview for Word (.doc/.docx). Please download to open locally.',
          zh: '参考附件不支持在系统内预览 Word（.doc/.docx）格式，请下载后在本地打开。',
        },
        pdfErrorOrSelect: {
          vi: 'Không tải được file. Thử tải xuống hoặc chọn file khác.',
          en: 'Failed to load file. Try downloading or choose another file.',
          zh: '无法加载文件，请尝试下载或选择其他文件。',
        },
        selectFileToPreview: {
          vi: 'Chọn file bên phải để xem trước.',
          en: 'Select a file on the right to preview.',
          zh: '请选择右侧文件进行预览。',
        },
        downloadUploadedSuffix: {
          vi: '✓ Đã tải lên',
          en: '✓ Uploaded',
          zh: '✓ 已上传',
        },
        uploadProgressSuffix: {
          vi: '{percent}%',
          en: '{percent}%',
          zh: '{percent}%',
        },
      },
      buttons: {
        back: {
          vi: 'Quay lại',
          en: 'Back',
          zh: '返回',
        },
        edit: {
          vi: 'Chỉnh sửa',
          en: 'Edit',
          zh: '编辑',
        },
        viewAttachments: {
          vi: 'Xem tệp đính kèm',
          en: 'View attachments',
          zh: '查看附件',
        },
        xinYKien: {
          vi: 'Xin ý kiến',
          en: 'Request opinion',
          zh: '征求意见',
        },
        trinhLdBophan: {
          vi: 'Trình lãnh đạo bộ phận',
          en: 'Submit to department leader',
          zh: '提交部门领导',
        },
        trinhLdDonvi: {
          vi: 'Trình lãnh đạo đơn vị',
          en: 'Submit to unit leader',
          zh: '提交单位领导',
        },
        pheDuyetChuyenVanThu: {
          vi: 'Phê duyệt & Chuyển văn thư',
          en: 'Approve & forward to clerk',
          zh: '审批并转文书',
        },
        banHanh: {
          vi: 'Ban hành',
          en: 'Issue document',
          zh: '发布',
        },
        ketThuc: {
          vi: 'Kết thúc',
          en: 'Complete',
          zh: '完成',
        },
        layLai: {
          vi: 'Lấy lại',
          en: 'Reopen',
          zh: '重新打开',
        },
        traLai: {
          vi: 'Trả lại',
          en: 'Return',
          zh: '退回',
        },
        huyBo: {
          vi: 'Hủy bỏ',
          en: 'Cancel',
          zh: '取消',
        },
        luuNhap: {
          vi: 'Lưu nháp',
          en: 'Save draft',
          zh: '保存草稿',
        },
        luuNhapLoading: {
          vi: 'Đang lưu...',
          en: 'Saving...',
          zh: '保存中...',
        },
        sendingLoading: {
          vi: 'Đang gửi...',
          en: 'Sending...',
          zh: '发送中...',
        },
        processingLoading: {
          vi: 'Đang xử lý...',
          en: 'Processing...',
          zh: '处理中...',
        },
      },
      errors: {
        leaderDonviRequired: {
          vi: 'Lãnh đạo đơn vị không được để trống.',
          en: 'Unit leader is required.',
          zh: '请选择单位领导。',
        },
        leaderBophanRequired: {
          vi: 'Lãnh đạo bộ phận không được để trống.',
          en: 'Department leader is required.',
          zh: '请选择部门领导。',
        },
        vanThuRequired: {
          vi: 'Vui lòng chọn văn thư đi.',
          en: 'Please select an outgoing clerk.',
          zh: '请选择发文文书。',
        },
      },
    },
    detail: {
      pdfFileNameFallback: {
        vi: 'van-ban.pdf',
        en: 'document.pdf',
        zh: 'document.pdf',
      },
      pdfIframeTitle: {
        vi: 'Xem trước văn bản',
        en: 'Document preview',
        zh: '文档预览',
      },
      pdfZoomInTitle: {
        vi: 'Phóng to',
        en: 'Zoom in',
        zh: '放大',
      },
      pdfZoomOutTitle: {
        vi: 'Thu nhỏ',
        en: 'Zoom out',
        zh: '缩小',
      },
      pdfDownloadTitle: {
        vi: 'Tải xuống',
        en: 'Download',
        zh: '下载',
      },
      pdfNoPreviewMessage: {
        vi: 'Không thể xem trước file này. Vui lòng tải xuống để xem.',
        en: 'Cannot preview this file. Please download it to view.',
        zh: '无法预览此文件，请下载查看。',
      },
      pdfConvertingMessage: {
        vi: 'Đang chuyển đổi sang PDF... Vui lòng đợi trong giây lát.',
        en: 'Converting to PDF... Please wait a moment.',
        zh: '正在转换为 PDF，请稍候。',
      },
      pdfNoFileMessage: {
        vi: 'Chưa có file đính kèm.',
        en: 'No attachments yet.',
        zh: '暂无附件。',
      },
      actionsNeeded: {
        empty: {
          vi: 'Chưa có hành động nào được gán.',
          en: 'No actions have been assigned.',
          zh: '尚未分配任何操作。',
        },
        xinYKienButton: {
          vi: 'Xin ý kiến',
          en: 'Request opinion',
          zh: '征求意见',
        },
        xinYKienConfirm: {
          vi: 'Xác nhận xin ý kiến',
          en: 'Confirm opinion',
          zh: '确认意见',
        },
      },
      xinYKienDialog: {
        title: {
          vi: 'Xin ý kiến',
          en: 'Request opinion',
          zh: '征求意见',
        },
        userLabel: {
          vi: 'Người được xin ý kiến',
          en: 'Recipient of opinion request',
          zh: '征求意见对象',
        },
        userPlaceholder: {
          vi: 'Chọn hoặc tìm người được xin ý kiến',
          en: 'Select or search for a recipient',
          zh: '选择或搜索征求意见对象',
        },
        noteLabel: {
          vi: 'Ghi chú (không bắt buộc)',
          en: 'Note (optional)',
          zh: '备注（选填）',
        },
        notePlaceholder: {
          vi: 'Nhập nội dung xin ý kiến...',
          en: 'Enter opinion request content...',
          zh: '输入征求意见内容...',
        },
        selectUserError: {
          vi: 'Vui lòng chọn người được xin ý kiến.',
          en: 'Please select a recipient.',
          zh: '请选择征求意见对象。',
        },
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        submit: {
          vi: 'Gửi xin ý kiến',
          en: 'Send request',
          zh: '发送',
        },
        submitting: {
          vi: 'Đang xử lý...',
          en: 'Processing...',
          zh: '处理中...',
        },
      },
      noteDialog: {
        title: {
          vi: 'Ghi chú',
          en: 'Note',
          zh: '备注',
        },
        label: {
          vi: 'Ghi chú (không bắt buộc)',
          en: 'Note (optional)',
          zh: '备注（选填）',
        },
        placeholder: {
          vi: 'Nhập ghi chú...',
          en: 'Enter note...',
          zh: '输入备注...',
        },
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        confirm: {
          vi: 'Xác nhận',
          en: 'Confirm',
          zh: '确认',
        },
      },
      sendDialog: {
        title: {
          vi: 'Gửi đi',
          en: 'Send out',
          zh: '发出',
        },
        externalUnitLabel: {
          vi: 'Nơi nhận đơn vị bên ngoài (cấp 0, cấp 1)',
          en: 'External receiving units (level 0, level 1)',
          zh: '外部收文单位（0级、1级）',
        },
        externalUnitPlaceholder: {
          vi: 'Chọn hoặc gõ tìm kiếm đơn vị...',
          en: 'Select or type to search units...',
          zh: '选择或输入搜索单位...',
        },
        viewerLabel: {
          vi: 'Người xem để biết',
          en: 'Viewers for information',
          zh: '抄送知悉人',
        },
        viewerPlaceholder: {
          vi: 'Chọn hoặc gõ tìm kiếm người xem để biết...',
          en: 'Select or type to search viewers...',
          zh: '选择或输入搜索抄送人...',
        },
        personalGroupLabel: {
          vi: 'Nhóm cá nhân xem để biết',
          en: 'Personal groups for information',
          zh: '个人分组抄送',
        },
        personalGroupPlaceholder: {
          vi: 'Chọn hoặc gõ tìm kiếm nhóm cá nhân...',
          en: 'Select or type to search personal groups...',
          zh: '选择或输入搜索个人分组...',
        },
        errorNoUnit: {
          vi: 'Vui lòng chọn ít nhất một nơi nhận đơn vị bên ngoài (cấp 0, cấp 1).',
          en: 'Please select at least one external receiving unit (level 0 or 1).',
          zh: '请至少选择一个外部收文单位（0级或1级）。',
        },
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        submit: {
          vi: 'Gửi đi',
          en: 'Send',
          zh: '发送',
        },
      },
      confirmSendAfterBanHanh: {
        title: {
          vi: 'Gửi văn bản',
          en: 'Send document',
          zh: '发送文档',
        },
        message: {
          vi: 'Bạn có muốn gửi văn bản ban hành này đến các đơn vị khác không?',
          en: 'Do you want to send this issued document to other units?',
          zh: '是否将此已发布文档发送给其他单位？',
        },
        no: { vi: 'Không', en: 'No', zh: '否' },
        yes: { vi: 'Có', en: 'Yes', zh: '是' },
      },
      twoFADialog: {
        title: {
          vi: 'Xác thực 2 bước',
          en: 'Two-factor authentication',
          zh: '两步验证',
        },
        submitButtonText: {
          vi: 'Xác nhận và gửi đi',
          en: 'Confirm and send',
          zh: '确认并发送',
        },
      },
      toast: {
        genericSuccess: {
          vi: 'Thao tác thành công.',
          en: 'Action completed successfully.',
          zh: '操作成功。',
        },
        xinYKienSuccess: {
          vi: 'Đã gửi xin ý kiến.',
          en: 'Opinion request sent.',
          zh: '已发送征求意见。',
        },
        ketThucSuccess: {
          vi: 'Đã kết thúc xử lý.',
          en: 'Marked as completed.',
          zh: '已标记为完成。',
        },
        sendSuccessWithIds: {
          vi: (count: number, ids: string) =>
            `Đã tạo ${count} văn bản đến ID: ${ids}`,
          en: (count: number, ids: string) =>
            `Created ${count} incoming documents with ID: ${ids}`,
          zh: (count: number, ids: string) =>
            `已创建 ${count} 份来文，ID：${ids}`,
        },
        sendSuccessNoIds: {
          vi: 'Gửi đi thành công.',
          en: 'Send succeeded.',
          zh: '发送成功。',
        },
      },
      errors: {
        detailFetchFailed: {
          vi: 'Không tải được chi tiết văn bản.',
          en: 'Failed to load document details.',
          zh: '加载文档详情失败。',
        },
        detailFetchError: {
          vi: 'Lỗi khi tải chi tiết văn bản.',
          en: 'Error while loading document details.',
          zh: '加载文档详情时出错。',
        },
        xinYKienConfirmFailed: {
          vi: 'Lỗi khi xác nhận xin ý kiến.',
          en: 'Error while confirming opinion.',
          zh: '确认意见时出错。',
        },
        ketThucFailed: {
          vi: 'Kết thúc xử lý thất bại.',
          en: 'Failed to mark as completed.',
          zh: '标记完成失败。',
        },
        returnStepFailed: {
          vi: 'Trả về bước trước thất bại.',
          en: 'Failed to return to previous step.',
          zh: '退回上一步失败。',
        },
        returnStepError: {
          vi: 'Lỗi khi trả về bước trước.',
          en: 'Error while returning to previous step.',
          zh: '退回上一步时出错。',
        },
        sendConfigError: {
          vi: 'Lỗi kiểm tra cấu hình.',
          en: 'Error while checking configuration.',
          zh: '检查配置时出错。',
        },
        sendError: {
          vi: 'Lỗi khi gửi đi.',
          en: 'Error while sending.',
          zh: '发送时出错。',
        },
        sendConfigAuthError: {
          vi: 'Lỗi kiểm tra cấu hình xác thực.',
          en: 'Error while checking authentication configuration.',
          zh: '检查认证配置时出错。',
        },
        twoFAVerifyFailed: {
          vi: 'Xác thực 2 bước thất bại.',
          en: 'Two-factor authentication failed.',
          zh: '两步验证失败。',
        },
        twoFACodeInvalid: {
          vi: 'Mã xác thực không đúng.',
          en: 'Invalid verification code.',
          zh: '验证码无效。',
        },
        uploadAttachmentFailed: {
          vi: 'Upload file đính kèm thất bại.',
          en: 'Failed to upload attachment.',
          zh: '上传附件失败。',
        },
        guiDiError: {
          vi: 'Lỗi khi gửi đi.',
          en: 'Error while sending.',
          zh: '发送时出错。',
        },
      },
    },
    review: {
      stepperHeaderTitle: {
        vi: 'Quy trình phê duyệt văn bản đi',
        en: 'Outgoing document approval process',
        zh: '发文审批流程',
      },
      pdfIframeTitle: {
        vi: 'Xem trước văn bản',
        en: 'Document preview',
        zh: '文档预览',
      },
      pdfUnsupportedMessage: {
        vi: 'File "{name}" không hỗ trợ xem trước trong trình duyệt. Vui lòng tải xuống để xem.',
        en: 'File "{name}" cannot be previewed in the browser. Please download it to view.',
        zh: '文件 "{name}" 无法在浏览器中预览，请下载查看。',
      },
      pdfEmptyMessage: {
        vi: 'Chưa có file đính kèm.',
        en: 'No attachments yet.',
        zh: '暂无附件。',
      },
      xinYKienDialog: {
        title: {
          vi: 'Xin ý kiến',
          en: 'Request opinion',
          zh: '征求意见',
        },
        userLabel: {
          vi: 'Người được xin ý kiến',
          en: 'Recipient of opinion request',
          zh: '征求意见对象',
        },
        userPlaceholder: {
          vi: 'Chọn hoặc tìm người được xin ý kiến',
          en: 'Select or search for a recipient',
          zh: '选择或搜索征求意见对象',
        },
        noteLabel: {
          vi: 'Ghi chú (không bắt buộc)',
          en: 'Note (optional)',
          zh: '备注（选填）',
        },
        notePlaceholder: {
          vi: 'Nhập ghi chú kèm theo...',
          en: 'Enter an optional note...',
          zh: '输入备注（选填）...',
        },
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        submit: {
          vi: 'Gửi xin ý kiến',
          en: 'Send request',
          zh: '发送',
        },
      },
      noteDialog: {
        titleDefault: {
          vi: 'Ghi chú',
          en: 'Note',
          zh: '备注',
        },
        titleBanHanh: {
          vi: 'Ban hành văn bản',
          en: 'Issue document',
          zh: '发布文档',
        },
        titlePheDuyet: {
          vi: 'Phê duyệt và chuyển văn thư',
          en: 'Approve & forward to clerk',
          zh: '审批并转文书',
        },
        noteLabel: {
          vi: 'Ghi chú (không bắt buộc)',
          en: 'Note (optional)',
          zh: '备注（选填）',
        },
        notePlaceholder: {
          vi: 'Nhập ghi chú...',
          en: 'Enter note...',
          zh: '请输入备注...',
        },
        vanThuLabel: {
          vi: 'Văn thư đi (chuyển văn thư sau phê duyệt)',
          en: 'Outgoing clerk (after approval)',
          zh: '发文文书（审批后转文书）',
        },
        vanThuPlaceholder: {
          vi: '— Chọn văn thư —',
          en: '— Select clerk —',
          zh: '— 选择文书 —',
        },
        vanThuNone: {
          vi: 'Không có văn thư đi trong cùng đơn vị.',
          en: 'No outgoing clerk in the same unit.',
          zh: '同单位暂无发文文书。',
        },
        viewersLabel: {
          vi: 'Chọn thêm người xem để biết',
          en: 'Select additional viewers for information',
          zh: '选择其他阅知人',
        },
        viewersPlaceholder: {
          vi: 'Chưa chọn',
          en: 'Not selected',
          zh: '未选择',
        },
        viewersInputPlaceholder: {
          vi: 'Tìm hoặc chọn người xem',
          en: 'Search or select viewers',
          zh: '搜索或选择阅知人',
        },
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        confirm: {
          vi: 'Xác nhận',
          en: 'Confirm',
          zh: '确认',
        },
      },
      twoFADialog: {
        title: {
          vi: 'Xác thực 2 bước',
          en: 'Two-factor authentication',
          zh: '两步验证',
        },
        submitButtonText: {
          vi: 'Xác nhận và phê duyệt',
          en: 'Confirm and approve',
          zh: '确认并审批',
        },
      },
      errors: {
        detailFetchFailed: {
          vi: 'Không tải được chi tiết văn bản.',
          en: 'Failed to load document details.',
          zh: '无法加载文档详情。',
        },
        detailFetchError: {
          vi: 'Lỗi khi tải chi tiết văn bản.',
          en: 'Error while loading document details.',
          zh: '加载文档详情时出错。',
        },
        updateStatusFailed: {
          vi: 'Cập nhật trạng thái thất bại.',
          en: 'Failed to update status.',
          zh: '更新状态失败。',
        },
        trinhLdDonviFailed: {
          vi: 'Lỗi khi trình lãnh đạo đơn vị.',
          en: 'Error while submitting to unit leader.',
          zh: '提交单位领导时出错。',
        },
        trinhLdBophanFailed: {
          vi: 'Trình lãnh đạo bộ phận thất bại.',
          en: 'Failed to submit to department leader.',
          zh: '提交部门领导失败。',
        },
        pheDuyetFailed: {
          vi: 'Phê duyệt thất bại.',
          en: 'Approval failed.',
          zh: '审批失败。',
        },
        pheDuyetError: {
          vi: 'Lỗi khi phê duyệt.',
          en: 'Error while approving.',
          zh: '审批时出错。',
        },
        banHanhFailed: {
          vi: 'Ban hành thất bại.',
          en: 'Issuance failed.',
          zh: '发布失败。',
        },
        banHanhError: {
          vi: 'Lỗi khi ban hành.',
          en: 'Error while issuing.',
          zh: '发布时出错。',
        },
        needEditSoVaSo: {
          vi: 'Bạn cần vào chỉnh sửa chọn sổ và số cho văn bản này.',
          en: 'You need to go to edit and select the registry and number for this document.',
          zh: '请进入编辑并选择本文档的登记簿和编号。',
        },
        yeuCauSuaDoiFailed: {
          vi: 'Chuyển về mới khởi tạo thất bại.',
          en: 'Failed to send back to draft.',
          zh: '退回到草稿失败。',
        },
        yeuCauSuaDoiError: {
          vi: 'Lỗi khi yêu cầu sửa đổi.',
          en: 'Error while requesting changes.',
          zh: '请求修改时出错。',
        },
        xinYKienSendFailed: {
          vi: 'Gửi xin ý kiến thất bại.',
          en: 'Failed to send opinion request.',
          zh: '发送征求意见失败。',
        },
        xinYKienSendError: {
          vi: 'Lỗi khi gửi xin ý kiến.',
          en: 'Error while sending opinion request.',
          zh: '发送征求意见时出错。',
        },
        documentIdInvalid: {
          vi: 'Không xác định được ID văn bản.',
          en: 'Document ID could not be determined.',
          zh: '无法确定文档 ID。',
        },
        twoFACodeInvalid: {
          vi: 'Mã xác thực không đúng.',
          en: 'Invalid verification code.',
          zh: '验证码无效。',
        },
        twoFAVerifyFailed: {
          vi: 'Xác thực 2 bước thất bại.',
          en: 'Two-factor authentication failed.',
          zh: '两步验证失败。',
        },
        configError: {
          vi: 'Lỗi kiểm tra cấu hình.',
          en: 'Error while checking configuration.',
          zh: '检查配置时出错。',
        },
      },
      successMessages: {
        trinhLdDonvi: {
          vi: 'Đã trình lãnh đạo đơn vị.',
          en: 'Submitted to unit leader.',
          zh: '已提交单位领导。',
        },
        trinhLdBophan: {
          vi: 'Đã trình lãnh đạo bộ phận.',
          en: 'Submitted to department leader.',
          zh: '已提交部门领导。',
        },
        pheDuyetChuyenVanThu: {
          vi: 'Đã phê duyệt và chuyển văn thư.',
          en: 'Approved and forwarded to clerk.',
          zh: '已审批并转文书。',
        },
        banHanh: {
          vi: 'Đã ban hành văn bản.',
          en: 'Document issued.',
          zh: '文档已发布。',
        },
        xinYKien: {
          vi: 'Đã gửi xin ý kiến.',
          en: 'Opinion request sent.',
          zh: '已发送征求意见。',
        },
      },
    },
    form: {
      headerTitle: {
        vi: 'Quy trình soạn thảo văn bản đi',
        en: 'Outgoing document drafting process',
        zh: '发文拟稿流程',
      },
      headerStatusChipPrefix: {
        vi: 'ID văn bản:',
        en: 'Document ID:',
        zh: '文档 ID：',
      },
      headerStatusChipLabel: {
        vi: 'Trạng thái',
        en: 'Status',
        zh: '状态',
      },
      detailCardTitle: {
        vi: 'Thông tin chi tiết',
        en: 'Detailed information',
        zh: '详细信息',
      },
      fields: {
        titleLabel: {
          vi: 'Trích yếu nội dung',
          en: 'Summary',
          zh: '摘要',
        },
        titleRequiredSuffix: {
          vi: '*',
          en: '*',
          zh: '*',
        },
        titlePlaceholder: {
          vi: 'Nhập trích yếu nội dung văn bản...',
          en: 'Enter document summary...',
          zh: '请输入文档摘要...',
        },
        docsGroupLabel: {
          vi: 'Sổ văn bản',
          en: 'Document registry',
          zh: '文档登记簿',
        },
        docsGroupPlaceholder: {
          vi: '— Chọn sổ văn bản —',
          en: '— Select registry —',
          zh: '— 选择登记簿 —',
        },
        documentNumberLabel: {
          vi: 'Số văn bản',
          en: 'Document no.',
          zh: '文档编号',
        },
        documentNumberPlaceholder: {
          vi: 'Nhập số văn bản...',
          en: 'Enter document number...',
          zh: '请输入文档编号...',
        },
        documentCodeLabel: {
          vi: 'Ký hiệu văn bản',
          en: 'Document symbol',
          zh: '文号',
        },
        documentCodePlaceholder: {
          vi: 'Nhập ký hiệu...',
          en: 'Enter symbol...',
          zh: '请输入文号...',
        },
        docsCatalogLabel: {
          vi: 'Loại văn bản',
          en: 'Document type',
          zh: '公文类型',
        },
        docsCatalogRequired: {
          vi: '*',
          en: '*',
          zh: '*',
        },
        docsCatalogPlaceholder: {
          vi: 'Chọn loại văn bản',
          en: 'Select document type',
          zh: '选择公文类型',
        },
        issuingUnitLabel: {
          vi: 'Đơn vị ban hành',
          en: 'Issuing unit',
          zh: '发文单位',
        },
        issuingUnitPlaceholder: {
          vi: 'Nhập đơn vị ban hành...',
          en: 'Enter issuing unit...',
          zh: '请输入发文单位...',
        },
        priorityLabel: {
          vi: 'Độ khẩn',
          en: 'Priority',
          zh: '紧急程度',
        },
        securityLevelLabel: {
          vi: 'Độ mật',
          en: 'Security level',
          zh: '密级',
        },
        leaderBophanLabel: {
          vi: 'Lãnh đạo bộ phận',
          en: 'Department leader',
          zh: '部门领导',
        },
        leaderBophanPlaceholder: {
          vi: 'Chọn lãnh đạo bộ phận',
          en: 'Select department leader',
          zh: '选择部门领导',
        },
        leaderDonviLabel: {
          vi: 'Lãnh đạo đơn vị',
          en: 'Unit leader',
          zh: '单位领导',
        },
        leaderDonviPlaceholder: {
          vi: 'Chọn lãnh đạo đơn vị',
          en: 'Select unit leader',
          zh: '选择单位领导',
        },
        documentDateLabel: {
          vi: 'Ngày văn bản',
          en: 'Document date',
          zh: '文档日期',
        },
        dueDateLabel: {
          vi: 'Hạn xử lý',
          en: 'Processing deadline',
          zh: '处理截止日期',
        },
        receiverLabel: {
          vi: 'Nơi nhận',
          en: 'Recipients',
          zh: '收件单位',
        },
        receiverPlaceholder: {
          vi: '— Chọn đơn vị (cấp 0, 1) —',
          en: '— Select units (level 0, 1) —',
          zh: '— 选择单位（0 级、1 级）—',
        },
        descriptionLabel: {
          vi: 'Mô tả / Ghi chú',
          en: 'Description / Notes',
          zh: '描述 / 备注',
        },
        descriptionPlaceholder: {
          vi: 'Nhập mô tả hoặc ghi chú...',
          en: 'Enter description or notes...',
          zh: '请输入描述或备注...',
        },
        tagsLabel: {
          vi: 'Tags',
          en: 'Tags',
          zh: '标签',
        },
        tagsPlaceholder: {
          vi: 'Nhập tag và nhấn Enter...',
          en: 'Enter a tag and press Enter...',
          zh: '输入标签并按 Enter...',
        },
      },
      priorityOptions: {
        thuong: { vi: 'Thường', en: 'Normal', zh: '普通' },
        khan: { vi: 'Khẩn', en: 'Urgent', zh: '紧急' },
        hoaToc: { vi: 'Hỏa tốc', en: 'Express', zh: '特急' },
        Thường: { vi: 'Thường', en: 'Normal', zh: '普通' },
        Khẩn: { vi: 'Khẩn', en: 'Urgent', zh: '紧急' },
        'Hỏa tốc': { vi: 'Hỏa tốc', en: 'Express', zh: '特急' },
      },
      securityOptions: {
        thuong: { vi: 'Thường', en: 'Normal', zh: '普通' },
        mat: { vi: 'Mật', en: 'Confidential', zh: '机密' },
        toiMat: { vi: 'Tối mật', en: 'Top secret', zh: '绝密' },
        Thường: { vi: 'Thường', en: 'Normal', zh: '普通' },
        Mật: { vi: 'Mật', en: 'Confidential', zh: '机密' },
        'Tối mật': { vi: 'Tối mật', en: 'Top secret', zh: '绝密' },
      },
      approvalFlow: {
        title: {
          vi: 'Luồng phê duyệt dự kiến',
          en: 'Expected approval workflow',
          zh: '预期审批流程',
        },
        roles: {
          soanThao: {
            vi: 'Người soạn',
            en: 'Drafter',
            zh: '拟稿人',
          },
          truongBoPhan: {
            vi: 'Trưởng bộ phận',
            en: 'Department leader',
            zh: '部门领导',
          },
          lanhDaoDonVi: {
            vi: 'Lãnh đạo đơn vị',
            en: 'Unit leader',
            zh: '单位领导',
          },
          vanThu: {
            vi: 'Văn thư',
            en: 'Clerk',
            zh: '文书',
          },
        },
        descriptions: {
          truongBoPhan: {
            vi: 'Phê duyệt chuyên môn',
            en: 'Technical approval',
            zh: '专业审批',
          },
          lanhDaoDonVi: {
            vi: 'Ký số ban hành',
            en: 'Digital signing & issuance',
            zh: '签章发布',
          },
          vanThu: {
            vi: 'Xác nhận ban hành',
            en: 'Issuance confirmation',
            zh: '发布确认',
          },
        },
      },
      attachments: {
        cardTitle: {
          vi: 'Tài liệu đính kèm',
          en: 'Attached documents',
          zh: '附件',
        },
        categoryLabel: {
          vi: 'Loại file:',
          en: 'File type:',
          zh: '文件类型：',
        },
        categoryOptions: {
          main: {
            vi: 'File chính (ký số)',
            en: 'Main file (for signing)',
            zh: '主文件（签章）',
          },
          reference: {
            vi: 'File đính kèm',
            en: 'Attachment',
            zh: '附件',
          },
        },
        uploadTitle: {
          vi: 'Nhấn để tải lên tài liệu',
          en: 'Click to upload documents',
          zh: '点击上传文件',
        },
        uploadHint: {
          vi: 'PDF, DOC, DOCX, XLSX, ẢNH (JPG/JPEG/PNG) và FILE NÉN (ZIP/RAR)',
          en: 'PDF, DOC, DOCX, XLSX, images (JPG/JPEG/PNG) and compressed files (ZIP/RAR)',
          zh: 'PDF、DOC、DOCX、XLSX、图片（JPG/JPEG/PNG）和压缩文件（ZIP/RAR）',
        },
        uploadedMark: {
          vi: '✓ Đã tải lên',
          en: '✓ Uploaded',
          zh: '✓ 已上传',
        },
        mainChip: {
          vi: 'File chính',
          en: 'Main file',
          zh: '主文件',
        },
        referenceChip: {
          vi: 'Đính kèm',
          en: 'Attachment',
          zh: '附件',
        },
        previewPdfOnly: {
          vi: 'Hiện chỉ hỗ trợ xem trước file PDF. Vui lòng tải xuống để xem.',
          en: 'Only PDF preview is supported. Please download to view.',
          zh: '仅支持 PDF 预览，请下载查看。',
        },
        deleteConfirmTitle: {
          vi: 'Xác nhận xóa file',
          en: 'Confirm file deletion',
          zh: '确认删除文件',
        },
        deleteConfirmDescription: {
          vi: 'Bạn có chắc chắn muốn xóa file "{name}" không?',
          en: 'Are you sure you want to delete file "{name}"?',
          zh: '确定要删除文件 "{name}" 吗？',
        },
        deleteCancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        deleteConfirm: {
          vi: 'Xóa',
          en: 'Delete',
          zh: '删除',
        },
      },
      bottomBar: {
        cancel: {
          vi: 'Hủy bỏ',
          en: 'Cancel',
          zh: '取消',
        },
        xinYKien: {
          vi: 'Xin ý kiến',
          en: 'Request opinion',
          zh: '征求意见',
        },
        saveDraft: {
          vi: 'Lưu nháp',
          en: 'Save draft',
          zh: '保存草稿',
        },
        saveDraftLoading: {
          vi: 'Đang lưu...',
          en: 'Saving...',
          zh: '保存中...',
        },
        trinhLdBophan: {
          vi: 'Trình lãnh đạo bộ phận',
          en: 'Submit to department leader',
          zh: '提交部门领导',
        },
        trinhLdDonvi: {
          vi: 'Trình lãnh đạo đơn vị',
          en: 'Submit to unit leader',
          zh: '提交单位领导',
        },
        pheDuyetChuyenVanThu: {
          vi: 'Phê duyệt và chuyển văn thư',
          en: 'Approve & forward to clerk',
          zh: '审批并转文书',
        },
        capNhat: {
          vi: 'Cập nhật',
          en: 'Update',
          zh: '更新',
        },
      },
      xinYKienDialog: {
        title: {
          vi: 'Xin ý kiến',
          en: 'Request opinion',
          zh: '征求意见',
        },
        userLabel: {
          vi: 'Người được xin ý kiến',
          en: 'Recipient of opinion request',
          zh: '征求意见对象',
        },
        userPlaceholder: {
          vi: 'Chọn hoặc tìm người được xin ý kiến',
          en: 'Select or search for a recipient',
          zh: '选择或搜索征求意见对象',
        },
        noteLabel: {
          vi: 'Ghi chú (không bắt buộc)',
          en: 'Note (optional)',
          zh: '备注（选填）',
        },
        notePlaceholder: {
          vi: 'Nhập ghi chú kèm theo...',
          en: 'Enter an optional note...',
          zh: '请输入备注...',
        },
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        submit: {
          vi: 'Gửi xin ý kiến',
          en: 'Send request',
          zh: '发送征求意见',
        },
      },
      noteDialog: {
        title: {
          vi: 'Ghi chú',
          en: 'Note',
          zh: '备注',
        },
        label: {
          vi: 'Ghi chú (không bắt buộc)',
          en: 'Note (optional)',
          zh: '备注（选填）',
        },
        placeholder: {
          vi: 'Nhập ghi chú...',
          en: 'Enter note...',
          zh: '请输入备注...',
        },
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        confirm: {
          vi: 'Xác nhận',
          en: 'Confirm',
          zh: '确认',
        },
      },
      twoFADialog: {
        title: {
          vi: 'Xác thực 2 bước',
          en: 'Two-factor authentication',
          zh: '两步验证',
        },
        submitButtonText: {
          vi: 'Xác nhận và phê duyệt',
          en: 'Confirm and approve',
          zh: '确认并审批',
        },
      },
      log: {
        emptyShort: {
          vi: 'Chưa có log xử lý.',
          en: 'No processing log yet.',
          zh: '暂无处理日志。',
        },
        expandButton: {
          vi: 'Mở rộng',
          en: 'Expand',
          zh: '展开',
        },
        modalTitle: {
          vi: 'Log xử lý',
          en: 'Processing log',
          zh: '处理日志',
        },
      },
      messages: {
        missingTitle: {
          vi: 'Vui lòng nhập trích yếu nội dung',
          en: 'Please enter the summary',
          zh: '请输入摘要',
        },
        missingDocsCatalog: {
          vi: 'Không tìm thấy loại văn bản "Công văn". Vui lòng chọn loại văn bản',
          en: 'Document type "Công văn" not found. Please select a document type',
          zh: '未找到公文类型，请选择公文类型',
        },
        missingMainFile: {
          vi: 'Vui lòng thêm ít nhất 1 file chính để ký số',
          en: 'Please add at least one main file for signing',
          zh: '请至少添加一个主文件用于签章',
        },
        missingLeaderBophan: {
          vi: 'Vui lòng chọn lãnh đạo bộ phận',
          en: 'Please select a department leader',
          zh: '请选择部门领导',
        },
        missingLeaderDonvi: {
          vi: 'Vui lòng chọn lãnh đạo đơn vị',
          en: 'Please select a unit leader',
          zh: '请选择单位领导',
        },
        missingVanThu: {
          vi: 'Vui lòng chọn văn thư đi',
          en: 'Please select an outgoing clerk',
          zh: '请选择发文文书',
        },
        unknownUser: {
          vi: 'Không xác định được người dùng',
          en: 'Cannot determine current user',
          zh: '无法识别当前用户',
        },
        requireSaveBeforeXinYKien: {
          vi: 'Vui lòng lưu nháp hoặc trình trước khi xin ý kiến.',
          en: 'Please save draft or submit before requesting opinion.',
          zh: '请先保存草稿或提交后再征求意见。',
        },
        xinYKienMissingUser: {
          vi: 'Vui lòng chọn người được xin ý kiến.',
          en: 'Please select a recipient.',
          zh: '请选择征求意见对象。',
        },
      },
      snackbar: {
        genericError: {
          vi: 'Có lỗi xảy ra',
          en: 'An error occurred',
          zh: '发生错误',
        },
        createError: {
          vi: 'Có lỗi xảy ra khi tạo văn bản',
          en: 'An error occurred while creating document',
          zh: '创建文档时出错',
        },
        updateError: {
          vi: 'Có lỗi xảy ra khi cập nhật văn bản',
          en: 'An error occurred while updating document',
          zh: '更新文档时出错',
        },
        createOrUpdateFailed: {
          vi: 'Có lỗi xảy ra khi lưu văn bản',
          en: 'Failed to save document',
          zh: '保存文档失败',
        },
        saveDraftSuccessNew: {
          vi: 'Đã lưu nháp thành công',
          en: 'Draft saved successfully',
          zh: '草稿保存成功',
        },
        saveDraftSuccessUpdate: {
          vi: 'Đã cập nhật nháp thành công',
          en: 'Draft updated successfully',
          zh: '草稿更新成功',
        },
        trinhLdBophanSuccess: {
          vi: 'Đã trình lãnh đạo bộ phận thành công',
          en: 'Submitted to department leader successfully',
          zh: '已成功提交部门领导',
        },
        trinhLdDonviSuccess: {
          vi: 'Đã trình lãnh đạo đơn vị thành công',
          en: 'Submitted to unit leader successfully',
          zh: '已成功提交单位领导',
        },
        pheDuyetChuyenVanThuSuccess: {
          vi: 'Đã phê duyệt và chuyển văn thư thành công',
          en: 'Approved and forwarded to clerk successfully',
          zh: '已审批并转文书',
        },
        xinYKienSuccess: {
          vi: 'Đã gửi xin ý kiến.',
          en: 'Opinion request sent.',
          zh: '已发送征求意见。',
        },
        deleteFileSuccess: {
          vi: 'Đã xóa file thành công',
          en: 'Deleted file successfully',
          zh: '文件已删除',
        },
        deleteFileFailed: {
          vi: 'Không thể xóa file',
          en: 'Cannot delete file',
          zh: '无法删除文件',
        },
      },
    },
    filePreviewDialog: {
      titleFallback: {
        vi: 'Xem trước file',
        en: 'File preview',
        zh: '文件预览',
      },
      iframeTitle: {
        vi: 'Xem trước file',
        en: 'File preview',
        zh: '文件预览',
      },
      cannotPreviewMessage: {
        vi: 'Không thể xem trước file này. Vui lòng thử tải xuống để xem.',
        en: 'Cannot preview this file. Please download it to view.',
        zh: '无法预览此文件，请下载查看。',
      },
      closeButton: {
        vi: 'Đóng',
        en: 'Close',
        zh: '关闭',
      },
    },
    chuyenXemDeBietDialog: {
      title: {
        vi: 'Chuyển xem để biết',
        en: 'Forward for information',
        zh: '抄送知悉',
      },
      selectedDocumentsInfo: {
        vi: (count: number) => `Đang chọn ${count} văn bản`,
        en: (count: number) => `Selected ${count} documents`,
        zh: (count: number) => `已选择 ${count} 份文档`,
      },
      noteLabel: {
        vi: 'Ghi chú',
        en: 'Note',
        zh: '备注',
      },
      notePlaceholder: {
        vi: 'Nhập ghi chú (không bắt buộc)...',
        en: 'Enter note (optional)...',
        zh: '输入备注（选填）...',
      },
      selectUsersLabel: {
        vi: 'Chọn người xem để biết (cùng đơn vị)',
        en: 'Select viewers (same unit)',
        zh: '选择抄送知悉人（同单位）',
      },
      selectUsersPlaceholder: {
        vi: 'Chưa chọn',
        en: 'Not selected',
        zh: '未选择',
      },
      noUsersInUnit: {
        vi: 'Không có người cùng đơn vị',
        en: 'No users in the same unit',
        zh: '同单位暂无用户',
      },
      errors: {
        noUserSelected: {
          vi: 'Vui lòng chọn ít nhất một người để chuyển xem để biết',
          en: 'Please select at least one viewer for information',
          zh: '请至少选择一位抄送知悉人',
        },
        submitFailed: {
          vi: 'Chuyển xem để biết thất bại',
          en: 'Forward for information failed',
          zh: '抄送知悉失败',
        },
        submitError: {
          vi: 'Lỗi khi chuyển xem để biết',
          en: 'Error while forwarding for information',
          zh: '抄送知悉时出错',
        },
      },
      buttons: {
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        confirm: {
          vi: 'Xác nhận',
          en: 'Confirm',
          zh: '确认',
        },
      },
    },
  },
  dashboard: {
    headerTitle: {
      vi: 'Dashboard Quản lý Văn bản',
      en: 'Document management dashboard',
      zh: '文档管理看板',
    },
    headerSubtitle: {
      vi: 'Chào mừng bạn trở lại hệ thống quản lý dự án PMIS.',
      en: 'Welcome back to the PMIS project management system.',
      zh: '欢迎回到 PMIS 项目管理系统。',
    },
    todayPrefix: {
      vi: 'Hôm nay',
      en: 'Today',
      zh: '今天',
    },
    status: {
      choXuLy: {
        vi: 'Chờ xử lý',
        en: 'Pending',
        zh: '待处理',
      },
      dangXemXet: {
        vi: 'Đang xem xét',
        en: 'Under review',
        zh: '审核中',
      },
      hoanThanh: {
        vi: 'Hoàn thành',
        en: 'Completed',
        zh: '已完成',
      },
      quaHan: {
        vi: 'Quá hạn',
        en: 'Overdue',
        zh: '已逾期',
      },
    },
    cards: {
      incomingNeedAction: {
        vi: 'VĂN BẢN ĐẾN CẦN XỬ LÝ',
        en: 'INCOMING DOCUMENTS REQUIRING ACTION',
        zh: '待处理来文',
      },
      incomingDraft: {
        vi: 'VĂN BẢN ĐẾN DỰ THẢO',
        en: 'INCOMING DRAFT DOCUMENTS',
        zh: '草稿来文',
      },
      outgoingNeedAction: {
        vi: 'VĂN BẢN ĐI CẦN XỬ LÝ',
        en: 'OUTGOING DOCUMENTS REQUIRING ACTION',
        zh: '待处理发文',
      },
      outgoingIssued: {
        vi: 'VĂN BẢN ĐI ĐÃ BAN HÀNH',
        en: 'ISSUED OUTGOING DOCUMENTS',
        zh: '已发文档',
      },
      incomingElectronic: {
        vi: 'VĂN BẢN ĐẾN ĐIỆN TỬ',
        en: 'INCOMING E-DOCUMENTS',
        zh: '电子来文',
      },
      incomingElectronicDescription: {
        vi: 'Văn bản điện tử mà đơn vị đã nhận, chờ văn thư xử lý.',
        en: 'Electronic incoming documents received by the unit, waiting for clerks to process.',
        zh: '单位已接收的电子来文，等待文书处理。',
      },
      incomingNeedActionDescription: {
        vi: 'Văn bản đến mà bạn hoặc cán bộ trong đơn vị cần xử lý.',
        en: 'Incoming documents that you or staff in your unit need to process.',
        zh: '需要您或本单位人员处理的来文。',
      },
      incomingDraftDescription: {
        vi: 'Văn bản đã có sổ/số, văn thư cần tiếp tục chuyển xử lý.',
        en: 'Documents that already have registry/number, clerks need to continue routing for processing.',
        zh: '已登记编号的文档，文书需继续流转处理。',
      },
      outgoingNeedActionDescription: {
        vi: 'Văn bản đi mà bạn còn nhiệm vụ xử lý hoặc trình duyệt.',
        en: 'Outgoing documents where you still have tasks to handle or approve.',
        zh: '您仍需处理或审批的发文。',
      },
      priorityBadge: {
        vi: 'Ưu tiên',
        en: 'Priority',
        zh: '优先',
      },
      notClerkWarning: {
        vi: 'Bạn không phải văn thư, không thể xem mục này.',
        en: 'You are not a clerk, you cannot access this item.',
        zh: '您不是文书人员，无法访问此项。',
      },
    },
    recentIncomingTitle: {
      vi: 'Văn bản đến gần đây',
      en: 'Recent incoming documents',
      zh: '最近来文',
    },
    viewAll: {
      vi: 'Xem tất cả',
      en: 'View all',
      zh: '查看全部',
    },
    recentIncomingColumns: {
      codeSummary: {
        vi: 'Số hiệu / Trích yếu',
        en: 'Number / Summary',
        zh: '文号 / 摘要',
      },
      date: {
        vi: 'Ngày đến',
        en: 'Received date',
        zh: '收文日期',
      },
      handler: {
        vi: 'Người xử lý',
        en: 'Handler',
        zh: '办理人',
      },
      status: {
        vi: 'Trạng thái',
        en: 'Status',
        zh: '状态',
      },
    },
    loading: {
      vi: 'Đang tải...',
      en: 'Loading...',
      zh: '加载中…',
    },
    empty: {
      vi: 'Không có dữ liệu',
      en: 'No data',
      zh: '暂无数据',
    },
    progressTitle: {
      vi: 'Tiến độ xử lý văn bản',
      en: 'Document processing progress',
      zh: '文档处理进度',
    },
    progressRangeLabel: {
      vi: 'Trong tháng',
      en: 'This month',
      zh: '本月',
    },
    progressSegments: {
      completedOnTime: {
        vi: 'Đã hoàn thành đúng hạn',
        en: 'Completed on time',
        zh: '按时完成',
      },
      inProgressOnTime: {
        vi: 'Đang xử lý trong hạn',
        en: 'In progress (on time)',
        zh: '按期处理中',
      },
      overdue: {
        vi: 'Chậm tiến độ',
        en: 'Overdue',
        zh: '进度滞后',
      },
    },
  },
  alertsPage: {
    title: {
      vi: 'Danh sách cảnh báo',
      en: 'Alerts',
      zh: '提醒列表',
    },
    subtitle: {
      vi: 'Thông báo module Tư vấn nhà thầu (theo cài đặt loại thông báo).',
      en: 'Consultant module notifications (respecting your notification preferences).',
      zh: '咨询模块通知（遵循您的通知设置）。',
    },
    empty: {
      vi: 'Không có cảnh báo.',
      en: 'No alerts.',
      zh: '暂无提醒。',
    },
    markAllRead: {
      vi: 'Đánh dấu tất cả đã đọc',
      en: 'Mark all as read',
      zh: '全部标为已读',
    },
    markingAll: {
      vi: 'Đang xử lý…',
      en: 'Processing…',
      zh: '处理中…',
    },
    colTime: {
      vi: 'Thời gian',
      en: 'Time',
      zh: '时间',
    },
    colTitle: {
      vi: 'Nội dung',
      en: 'Content',
      zh: '内容',
    },
    colType: {
      vi: 'Loại',
      en: 'Type',
      zh: '类型',
    },
    colStatus: {
      vi: 'Trạng thái',
      en: 'Status',
      zh: '状态',
    },
    read: {
      vi: 'Đã đọc',
      en: 'Read',
      zh: '已读',
    },
    unread: {
      vi: 'Chưa đọc',
      en: 'Unread',
      zh: '未读',
    },
  },
  sidebar: {
    items: {
      dashboard: {
        vi: 'Dashboard',
        en: 'Dashboard',
        zh: '仪表板',
      },
      searchOverview: {
        vi: 'Tìm kiếm tổng quan',
        en: 'Global search',
        zh: '全局搜索',
      },
      incomingList: {
        vi: 'Danh sách văn bản đến',
        en: 'Incoming documents',
        zh: '来文列表',
      },
      outgoingList: {
        vi: 'Danh sách văn bản đi',
        en: 'Outgoing documents',
        zh: '发文列表',
      },
      chat: {
        vi: 'Trao đổi',
        en: 'Discussions',
        zh: '讨论',
      },
      notifications: {
        vi: 'Cảnh báo',
        en: 'Alerts',
        zh: '提醒',
      },
      settings: {
        vi: 'Cài đặt',
        en: 'Settings',
        zh: '设置',
      },
    },
    outgoingFilters: {
      choXuLy: {
        vi: 'Chờ xử lý',
        en: 'Pending',
        zh: '待处理',
      },
      daXuLy: {
        vi: 'Đã xử lý',
        en: 'Processed',
        zh: '已处理',
      },
      daXoa: {
        vi: 'Văn bản đi đã xóa',
        en: 'Deleted outgoing documents',
        zh: '已删除发文',
      },
      xemDeBiet: {
        vi: 'Xem để biết',
        en: 'For information',
        zh: '知会',
      },
      all: {
        vi: 'Tra cứu văn bản',
        en: 'Search documents',
        zh: '查询公文',
      },
    },
    incomingFilters: {
      choXuLy: {
        vi: 'Chờ xử lý',
        en: 'Pending',
        zh: '待处理',
      },
      daXuLy: {
        vi: 'Đã xử lý',
        en: 'Processed',
        zh: '已处理',
      },
      dienTu: {
        vi: 'Văn bản điện tử',
        en: 'E-documents',
        zh: '电子来文',
      },
      duThao: {
        vi: 'Văn bản dự thảo',
        en: 'Draft documents',
        zh: '草稿来文',
      },
      daXoa: {
        vi: 'Văn bản đã xóa',
        en: 'Deleted documents',
        zh: '已删除来文',
      },
      all: {
        vi: 'Tra cứu văn bản',
        en: 'Search documents',
        zh: '查询公文',
      },
    },
    toggle: {
      expand: {
        vi: 'Mở rộng',
        en: 'Expand',
        zh: '展开',
      },
      collapse: {
        vi: 'Thu gọn',
        en: 'Collapse',
        zh: '收起',
      },
    },
  },
  settings: {
    sections: {
      system: {
        vi: 'Cài đặt hệ thống',
        en: 'System settings',
        zh: '系统设置',
      },
      security: {
        vi: 'Bảo mật',
        en: 'Security',
        zh: '安全',
      },
    },
    menu: {
      unitInfo: {
        vi: 'Thông tin đơn vị',
        en: 'Unit information',
        zh: '单位信息',
      },
      unitConfig: {
        vi: 'Cấu hình đơn vị',
        en: 'Unit configuration',
        zh: '单位配置',
      },
      unitEmail: {
        vi: 'Cài đặt Email',
        en: 'Email settings',
        zh: '邮件设置',
      },
      unitMembers: {
        vi: 'Thành viên đơn vị',
        en: 'Unit members',
        zh: '单位成员',
      },
      permissions: {
        vi: 'Phân quyền vai trò',
        en: 'Role permissions',
        zh: '角色权限',
      },
      documentRegistry: {
        vi: 'Quản lý sổ văn bản',
        en: 'Document registry',
        zh: '文书登记管理',
      },
      accessLog: {
        vi: 'Nhật ký truy cập',
        en: 'Access log',
        zh: '访问日志',
      },
    },
    underConstruction: {
      vi: 'Nội dung đang được phát triển...',
      en: 'Content is under development...',
      zh: '内容开发中…',
    },
    unitEmailPage: {
      title: {
        vi: 'Cài đặt email nhận thông báo văn bản',
        en: 'Email settings for documents',
        zh: '文档通知邮件设置',
      },
      unitLabelPrefix: {
        vi: 'Đơn vị của bạn:',
        en: 'Your unit:',
        zh: '您的单位：',
      },
      noUnitMessage: {
        vi: 'Tài khoản của bạn chưa được gán vào đơn vị nào. Không thể cấu hình email đơn vị.',
        en: 'Your account is not assigned to any unit. Unit email cannot be configured.',
        zh: '您的账号尚未关联到任何单位，无法配置单位邮箱。',
      },
      fields: {
        email: {
          vi: 'Email',
          en: 'Email',
          zh: '邮箱地址',
        },
        phone: {
          vi: 'Số điện thoại',
          en: 'Phone number',
          zh: '电话号码',
        },
        displayName: {
          vi: 'Tên hiển thị',
          en: 'Display name',
          zh: '显示名称',
        },
        cc: {
          vi: 'CC (email cách nhau bởi dấu phẩy)',
          en: 'CC (emails separated by commas)',
          zh: '抄送（多个邮箱用逗号分隔）',
        },
        ccPlaceholder: {
          vi: 'ví dụ: a@example.com, b@example.com',
          en: 'e.g.: a@example.com, b@example.com',
          zh: '例如：a@example.com, b@example.com',
        },
      },
      buttons: {
        save: {
          vi: 'Lưu thay đổi',
          en: 'Save changes',
          zh: '保存更改',
        },
        saving: {
          vi: 'Đang lưu...',
          en: 'Saving...',
          zh: '正在保存…',
        },
      },
      messages: {
        loadFailed: {
          vi: 'Không tải được thông tin email đơn vị',
          en: 'Failed to load unit email settings',
          zh: '无法加载单位邮箱配置',
        },
        loadError: {
          vi: 'Có lỗi xảy ra khi tải dữ liệu',
          en: 'An error occurred while loading data',
          zh: '加载数据时发生错误',
        },
        saveSuccess: {
          vi: 'Cập nhật email đơn vị thành công',
          en: 'Unit email updated successfully',
          zh: '单位邮箱更新成功',
        },
        saveFailed: {
          vi: 'Cập nhật thất bại',
          en: 'Update failed',
          zh: '更新失败',
        },
        saveError: {
          vi: 'Có lỗi xảy ra khi cập nhật',
          en: 'An error occurred while updating',
          zh: '更新时发生错误',
        },
      },
    },
    unitMembersPage: {
      title: {
        vi: 'Thành viên đơn vị',
        en: 'Unit members',
        zh: '单位成员',
      },
      unitLabelPrefix: {
        vi: 'Đơn vị của bạn:',
        en: 'Your unit:',
        zh: '您的单位：',
      },
      noUnitMessage: {
        vi: 'Tài khoản của bạn chưa được gán vào đơn vị nào.',
        en: 'Your account is not assigned to any unit.',
        zh: '您的账号尚未关联到任何单位。',
      },
      noMembersMessage: {
        vi: 'Chưa có thành viên nào trong đơn vị.',
        en: 'There are no members in this unit yet.',
        zh: '当前单位暂无成员。',
      },
      buttons: {
        addMember: {
          vi: 'Thêm người vào đơn vị',
          en: 'Add member to unit',
          zh: '添加单位成员',
        },
        close: {
          vi: 'Đóng',
          en: 'Close',
          zh: '关闭',
        },
        delete: {
          vi: 'Xóa',
          en: 'Delete',
          zh: '删除',
        },
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        save: {
          vi: 'Lưu',
          en: 'Save',
          zh: '保存',
        },
        adding: {
          vi: 'Đang thêm...',
          en: 'Adding...',
          zh: '正在添加…',
        },
        saving: {
          vi: 'Đang lưu...',
          en: 'Saving...',
          zh: '正在保存…',
        },
      },
      addDialog: {
        title: {
          vi: 'Thêm người vào đơn vị',
          en: 'Add member to unit',
          zh: '添加单位成员',
        },
        searchLabel: {
          vi: 'Tìm kiếm (username, họ tên, email)',
          en: 'Search (username, full name, email)',
          zh: '搜索（用户名、姓名、邮箱）',
        },
        noCandidates: {
          vi: 'Không có người dùng phù hợp.',
          en: 'No matching users.',
          zh: '没有符合条件的用户。',
        },
        addButton: {
          vi: 'Thêm',
          en: 'Add',
          zh: '添加',
        },
      },
      editDialog: {
        title: {
          vi: 'Chỉnh sửa người dùng',
          en: 'Edit user',
          zh: '编辑用户',
        },
        fields: {
          username: {
            vi: 'Tên đăng nhập',
            en: 'Username',
            zh: '用户名',
          },
          email: {
            vi: 'Email',
            en: 'Email',
            zh: '邮箱',
          },
          fullname: {
            vi: 'Họ và tên',
            en: 'Full name',
            zh: '姓名',
          },
          roles: {
            vi: 'Vai trò',
            en: 'Roles',
            zh: '角色',
          },
          groups: {
            vi: 'Nhóm',
            en: 'Groups',
            zh: '群组',
          },
          department: {
            vi: 'Đơn vị',
            en: 'Department',
            zh: '部门',
          },
          position: {
            vi: 'Chức vụ',
            en: 'Position',
            zh: '职务',
          },
          positionLabel: {
            vi: 'Nhãn chức vụ',
            en: 'Position label',
            zh: '职务标签',
          },
          isActive: {
            vi: 'Hoạt động',
            en: 'Active',
            zh: '启用',
          },
          noDepartmentOption: {
            vi: 'Không có',
            en: 'None',
            zh: '无',
          },
        },
      },
      roles: {
        VAN_THU_DEN: {
          vi: 'Văn thư đến',
          en: 'Incoming clerk',
          zh: '收文文员',
        },
        TRUONG_PHONG_HCTC: {
          vi: 'Trưởng phòng HCTC',
          en: 'Head of Administration & HR',
          zh: '行政人事处处长',
        },
        TRUONG_PHONG: {
          vi: 'Trưởng phòng',
          en: 'Department head',
          zh: '科室负责人',
        },
        TRUONG_BAN: {
          vi: 'Trưởng ban',
          en: 'Committee head',
          zh: '委员会主任',
        },
        NHAN_VIEN: {
          vi: 'Nhân viên',
          en: 'Staff',
          zh: '职员',
        },
        LANH_DAO_BAN: {
          vi: 'Lãnh đạo ban',
          en: 'Committee leader',
          zh: '委员会领导',
        },
        LANH_DAO_BOPHAN: {
          vi: 'Lãnh đạo bộ phận',
          en: 'Section leader',
          zh: '部门负责人',
        },
        LANH_DAO_DONVI: {
          vi: 'Lãnh đạo đơn vị',
          en: 'Unit leader',
          zh: '单位领导',
        },
        DUYET_LICH: {
          vi: 'Duyệt lịch',
          en: 'Schedule approver',
          zh: '日程审批人',
        },
        VAN_THU_DI: {
          vi: 'Văn thư đi',
          en: 'Outgoing clerk',
          zh: '发文文员',
        },
        ADMIN: {
          vi: 'Quản trị viên',
          en: 'Administrator',
          zh: '管理员',
        },
      },
      groups: {
        PhongLanhDaoBan: {
          vi: 'Phòng Lãnh đạo Ban',
          en: 'Management office',
          zh: '领导办公室',
        },
        PhongKeHoachTongHop: {
          vi: 'Phòng Kế hoạch Tổng hợp',
          en: 'Planning & General Department',
          zh: '计划与综合部',
        },
        PhongTaiChinhKeToan: {
          vi: 'Phòng Tài chính Kế toán',
          en: 'Finance & Accounting Department',
          zh: '财务会计部',
        },
        PhongHanhChinhToChuc: {
          vi: 'Phòng Hành chính Tổ chức',
          en: 'Administration & Organization Department',
          zh: '行政组织部',
        },
        PhongKiThuatThamDinh: {
          vi: 'Phòng Kỹ thuật Thẩm định',
          en: 'Technical Appraisal Department',
          zh: '技术评审部',
        },
        PhongQuanLyThucHienDuAn1: {
          vi: 'Phòng Quản lý Thực hiện Dự án 1',
          en: 'Project Implementation Management Dept. 1',
          zh: '项目实施管理一部',
        },
        PhongQuanLyThucHienDuAn2: {
          vi: 'Phòng Quản lý Thực hiện Dự án 2',
          en: 'Project Implementation Management Dept. 2',
          zh: '项目实施管理二部',
        },
        PhongQuanLyThucHienDuAn3: {
          vi: 'Phòng Quản lý Thực hiện Dự án 3',
          en: 'Project Implementation Management Dept. 3',
          zh: '项目实施管理三部',
        },
        PhongQuanLyThucHienDuAn4: {
          vi: 'Phòng Quản lý Thực hiện Dự án 4',
          en: 'Project Implementation Management Dept. 4',
          zh: '项目实施管理四部',
        },
      },
      messages: {
        loadMembersFailed: {
          vi: 'Không tải được danh sách',
          en: 'Failed to load members list',
          zh: '无法加载成员列表',
        },
        loadMembersError: {
          vi: 'Có lỗi xảy ra khi tải danh sách',
          en: 'An error occurred while loading the list',
          zh: '加载列表时发生错误',
        },
        loadUsersError: {
          vi: 'Có lỗi xảy ra khi tải danh sách người dùng',
          en: 'An error occurred while loading users',
          zh: '加载用户列表时发生错误',
        },
        addSuccess: {
          vi: 'Thêm người vào đơn vị thành công',
          en: 'Member added to unit successfully',
          zh: '成功添加单位成员',
        },
        addFailed: {
          vi: 'Thêm người thất bại',
          en: 'Failed to add member',
          zh: '添加成员失败',
        },
        addError: {
          vi: 'Có lỗi xảy ra khi thêm người',
          en: 'An error occurred while adding member',
          zh: '添加成员时发生错误',
        },
        removeConfirm: {
          vi: 'Bạn có chắc muốn gỡ người này khỏi đơn vị?',
          en: 'Are you sure you want to remove this member from the unit?',
          zh: '确定要将该成员从单位中移除吗？',
        },
        removeSuccess: {
          vi: 'Đã gỡ người khỏi đơn vị',
          en: 'Member removed from unit',
          zh: '已将该成员从单位中移除',
        },
        removeFailed: {
          vi: 'Gỡ người thất bại',
          en: 'Failed to remove member',
          zh: '移除成员失败',
        },
        removeError: {
          vi: 'Có lỗi xảy ra khi gỡ người',
          en: 'An error occurred while removing member',
          zh: '移除成员时发生错误',
        },
        updateSuccess: {
          vi: 'Cập nhật người dùng thành công',
          en: 'User updated successfully',
          zh: '用户更新成功',
        },
        updateFailed: {
          vi: 'Cập nhật thất bại',
          en: 'Update failed',
          zh: '更新失败',
        },
        updateError: {
          vi: 'Có lỗi xảy ra khi cập nhật người dùng',
          en: 'An error occurred while updating user',
          zh: '更新用户时发生错误',
        },
      },
    },
    unitConfigPage: {
      title: { vi: 'Cấu hình đơn vị', en: 'Unit configuration', zh: '单位配置' },
      subtitle: { vi: 'Thiết lập quy trình vận hành và các tham số mặc định cho tổ chức.', en: 'Set up workflows and default parameters for your organization.', zh: '为组织设置工作流程和默认参数。' },
      personalSecurityTitle: { vi: 'Cấu hình bảo mật cá nhân', en: 'Personal security settings', zh: '个人安全设置' },
      personalSecuritySubtitle: { vi: 'Bật hoặc tắt xác thực 2 bước và đổi mật khẩu đăng nhập.', en: 'Enable or disable two-factor authentication and change your login password.', zh: '启用或关闭两步验证并修改登录密码。' },
      buttons: {
        cancel: { vi: 'Hủy thay đổi', en: 'Discard changes', zh: '放弃更改' },
        save: { vi: 'Lưu cấu hình', en: 'Save configuration', zh: '保存配置' },
        connect: { vi: 'Kết nối', en: 'Connect', zh: '连接' },
        changePassword: { vi: 'Đổi mật khẩu', en: 'Change password', zh: '修改密码' },
        addLabel: { vi: 'Thêm nhãn mới', en: 'Add new label', zh: '添加新标签' },
        hideQr: { vi: 'Ẩn QR code', en: 'Hide QR code', zh: '隐藏二维码' },
        showQr: { vi: 'Hiển thị QR code', en: 'Show QR code', zh: '显示二维码' },
        cancelShort: { vi: 'Hủy', en: 'Cancel', zh: '取消' },
        confirm: { vi: 'Xác nhận', en: 'Confirm', zh: '确认' },
        addNew: { vi: 'Thêm mới', en: 'Add', zh: '添加' },
        update: { vi: 'Cập nhật', en: 'Update', zh: '更新' },
      },
      sections: {
        workflow: { vi: 'Cấu hình quy trình', en: 'Workflow settings', zh: '流程设置' },
        defaults: { vi: 'Thiết lập mặc định', en: 'Default settings', zh: '默认设置' },
        twoFA: { vi: 'Xác thực 2 bước', en: 'Two-factor authentication', zh: '双因素认证' },
        labels: { vi: 'Cấu hình nhãn', en: 'Label configuration', zh: '标签配置' },
        systemConnect: { vi: 'Kết nối hệ thống', en: 'System integration', zh: '系统集成' },
        passwordManage: { vi: 'Quản lý mật khẩu', en: 'Password management', zh: '密码管理' },
      },
      workflowItems: {
        planApproval: { title: { vi: 'Bắt buộc phê duyệt kế hoạch', en: 'Require plan approval', zh: '计划需审批' }, desc: { vi: 'Mọi kế hoạch cần được quản lý duyệt trước khi thực hiện', en: 'All plans must be approved by manager before execution', zh: '所有计划执行前须经管理员审批' } },
        completionEvidence: { title: { vi: 'Yêu cầu minh chứng khi hoàn thành', en: 'Require completion evidence', zh: '完成时需提供证明' }, desc: { vi: 'Đính kèm tài liệu/hình ảnh khi báo cáo kết quả', en: 'Attach documents/images when reporting results', zh: '报告结果时须附文档/图片' } },
        overdueReminder: { title: { vi: 'Tự động nhắc nhở quá hạn', en: 'Auto overdue reminder', zh: '逾期自动提醒' }, desc: { vi: 'Hệ thống gửi thông báo khi nhiệm vụ trễ hạn', en: 'System sends notification when tasks are overdue', zh: '任务逾期时系统发送通知' } },
      },
      defaultsFields: {
        priority: { vi: 'Độ ưu tiên mặc định', en: 'Default priority', zh: '默认优先级' },
        duration: { vi: 'Thời gian hoàn thành dự kiến (ngày)', en: 'Expected completion time (days)', zh: '预计完成时间（天）' },
        currency: { vi: 'Đơn vị tiền tệ', en: 'Currency', zh: '货币单位' },
      },
      priorityOptions: { low: { vi: 'Thấp', en: 'Low', zh: '低' }, medium: { vi: 'Trung bình', en: 'Medium', zh: '中' }, high: { vi: 'Cao', en: 'High', zh: '高' } },
      currencyOptions: { vnd: { vi: 'VND (Việt Nam Đồng)', en: 'VND (Vietnamese Dong)', zh: 'VND（越南盾）' }, usd: { vi: 'USD (US Dollar)', en: 'USD (US Dollar)', zh: 'USD（美元）' }, eur: { vi: 'EUR (Euro)', en: 'EUR (Euro)', zh: 'EUR（欧元）' } },
      twoFAItems: {
        totp: { title: { vi: 'TOTP (Google Authenticator)', en: 'TOTP (Google Authenticator)', zh: 'TOTP (Google Authenticator)' }, desc: { vi: 'Xác thực qua ứng dụng Google Authenticator hoặc tương tự', en: 'Authenticate via Google Authenticator or similar app', zh: '通过 Google Authenticator 或类似应用认证' } },
        mailOtp: { title: { vi: 'Mail OTP', en: 'Mail OTP', zh: '邮件 OTP' }, desc: { vi: 'Xác thực qua mã OTP gửi đến email', en: 'Authenticate via OTP code sent to email', zh: '通过发送到邮箱的 OTP 码认证' } },
      },
      totpConfirm: {
        title: { vi: 'Xác nhận tắt TOTP', en: 'Confirm disable TOTP', zh: '确认关闭 TOTP' },
        message: { vi: 'Tắt TOTP (Google Authenticator) sẽ vô hiệu hóa mã TOTP hiện tại, bạn có chắc chắn muốn tắt?', en: 'Disabling TOTP will invalidate your current TOTP code. Are you sure?', zh: '关闭 TOTP 将使当前 TOTP 码失效，确定要关闭吗？' },
      },
      labelDialog: {
        createTitle: { vi: 'Thêm nhãn mới', en: 'Add new label', zh: '添加新标签' },
        editTitle: { vi: 'Cập nhật nhãn', en: 'Update label', zh: '更新标签' },
        labelName: { vi: 'Tên nhãn', en: 'Label name', zh: '标签名称' },
        colorBg: { vi: 'Màu nền', en: 'Background color', zh: '背景色' },
        colorFg: { vi: 'Màu chữ', en: 'Text color', zh: '文字颜色' },
        status: { vi: 'Trạng thái', en: 'Status', zh: '状态' },
        order: { vi: 'Thứ tự', en: 'Order', zh: '顺序' },
      },
      statusOptions: { active: { vi: 'Kích hoạt', en: 'Active', zh: '启用' }, inactive: { vi: 'Tạm dừng', en: 'Paused', zh: '暂停' } },
      integration: {
        calendar: { title: { vi: 'Tích hợp Calendar', en: 'Calendar integration', zh: '日历集成' }, desc: { vi: 'Đồng bộ lịch nhiệm vụ với Google/Outlook Calendar', en: 'Sync task calendar with Google/Outlook Calendar', zh: '与 Google/Outlook 日历同步任务' } },
        drive: { title: { vi: 'Google Drive / OneDrive', en: 'Google Drive / OneDrive', zh: 'Google Drive / OneDrive' }, desc: { vi: 'Kết nối tài khoản Google Drive hoặc OneDrive để lưu trữ tài liệu', en: 'Connect Google Drive or OneDrive to store documents', zh: '连接 Google Drive 或 OneDrive 存储文档' } },
      },
      passwordSection: {
        title: { vi: 'Đổi mật khẩu đăng nhập', en: 'Change login password', zh: '修改登录密码' },
        desc: { vi: 'Thay đổi mật khẩu tài khoản trên hệ thống xác thực (WSO2). Nếu bạn đã bật xác thực 2 bước, cần nhập mã TOTP hoặc Mail OTP.', en: 'Change account password on auth system (WSO2). If 2FA is enabled, you will need TOTP or Mail OTP.', zh: '在认证系统 (WSO2) 修改账户密码。若已启用双因素认证，需输入 TOTP 或邮件 OTP。' },
      },
      messages: {
        featureDeveloping: { vi: 'Tính năng đang phát triển', en: 'Feature under development', zh: '功能开发中' },
        loadConfigError: { vi: 'Có lỗi xảy ra khi tải cấu hình', en: 'An error occurred while loading configuration', zh: '加载配置时出错' },
        loadLabelsError: { vi: 'Có lỗi xảy ra khi tải nhãn', en: 'An error occurred while loading labels', zh: '加载标签时出错' },
        saveConfigError: { vi: 'Có lỗi xảy ra khi lưu cấu hình', en: 'An error occurred while saving configuration', zh: '保存配置时出错' },
        saveConfigSuccess: { vi: 'Lưu cấu hình thành công', en: 'Configuration saved successfully', zh: '配置已保存' },
        saveLabelFirst: { vi: 'Cần lưu cấu hình trước khi thêm nhãn.', en: 'Save configuration before adding labels.', zh: '添加标签前请先保存配置。' },
        saveLabelError: { vi: 'Có lỗi xảy ra khi lưu nhãn', en: 'An error occurred while saving label', zh: '保存标签时出错' },
        deleteLabelConfirm: { vi: 'Xóa nhãn "{{label}}"?', en: 'Delete label "{{label}}"?' , zh: '删除标签「{{label}}」？' },
        deleteLabelError: { vi: 'Có lỗi xảy ra khi xóa nhãn', en: 'An error occurred while deleting label', zh: '删除标签时出错' },
      },
    },
    unitInfoPage: {
      title: { vi: 'Thông tin đơn vị', en: 'Unit information', zh: '单位信息' },
      subtitle: { vi: 'Quản lý hồ sơ pháp lý và thông tin liên hệ của tổ chức.', en: 'Manage legal records and contact information of the organization.', zh: '管理组织证照及联系信息。' },
      buttons: {
        cancel: { vi: 'Hủy thay đổi', en: 'Discard changes', zh: '放弃更改' },
        update: { vi: 'Cập nhật thông tin', en: 'Update information', zh: '更新信息' },
        uploadDoc: { vi: 'Tải lên tài liệu', en: 'Upload document', zh: '上传文档' },
        connectAccount: { vi: 'Kết nối tài khoản', en: 'Connect account', zh: '连接账户' },
        cancelShort: { vi: 'Hủy', en: 'Cancel', zh: '取消' },
        upload: { vi: 'Tải lên', en: 'Upload', zh: '上传' },
        updateShort: { vi: 'Cập nhật', en: 'Update', zh: '更新' },
      },
      cards: {
        unitProfile: { vi: 'Hồ sơ đơn vị', en: 'Unit profile', zh: '单位档案' },
        representative: { vi: 'Thông tin người đại diện', en: 'Representative information', zh: '代表信息' },
        emailStructure: { vi: 'Cấu trúc email', en: 'Email setup', zh: '邮件设置' },
        legalProfile: { vi: 'Hồ sơ pháp lý', en: 'Legal documents', zh: '证照档案' },
      },
      fields: {
        unitName: { vi: 'Tên đơn vị', en: 'Unit name', zh: '单位名称' },
        taxCode: { vi: 'Mã số thuế', en: 'Tax code', zh: '税号' },
        phone: { vi: 'Số điện thoại', en: 'Phone', zh: '电话' },
        address: { vi: 'Địa chỉ', en: 'Address', zh: '地址' },
        website: { vi: 'Website', en: 'Website', zh: '网站' },
        logoUnit: { vi: 'LOGO ĐƠN VỊ', en: 'UNIT LOGO', zh: '单位标志' },
        logoAlt: { vi: 'Logo đơn vị', en: 'Unit logo', zh: '单位 Logo' },
        changeLogo: { vi: 'Thay đổi logo', en: 'Change logo', zh: '更换 Logo' },
        fullName: { vi: 'Họ và tên', en: 'Full name', zh: '姓名' },
        position: { vi: 'Chức vụ', en: 'Position', zh: '职务' },
        contactEmail: { vi: 'Email liên hệ', en: 'Contact email', zh: '联系邮箱' },
        emailAccount: { vi: 'Tài khoản email', en: 'Email account', zh: '邮箱账户' },
        passwordToken: { vi: 'Mật khẩu/ Token', en: 'Password / Token', zh: '密码/令牌' },
        passwordHint: { vi: 'Sử dụng mật khẩu ứng dụng để hệ thống có thể gửi thông báo thay mặt bạn', en: 'Use app password so the system can send notifications on your behalf', zh: '使用应用密码以便系统代您发送通知' },
        notificationOptions: { vi: 'Tùy chọn thông báo', en: 'Notification options', zh: '通知选项' },
        notifyNewTask: { vi: 'Gửi email khi có nhiệm vụ mới được giao', en: 'Send email when new tasks are assigned', zh: '分配新任务时发送邮件' },
        notifyDeadline: { vi: 'Gửi email nhắc nhở hạn hoàn thành (24h trước)', en: 'Send reminder email 24h before deadline', zh: '截止前 24 小时发送提醒邮件' },
        notifyDocApproved: { vi: 'Thông báo khi tài liệu được phê duyệt', en: 'Notify when document is approved', zh: '文档审批通过时通知' },
        weeklyReport: { vi: 'Báo cáo tổng kết tuần tự động', en: 'Automatic weekly summary report', zh: '自动周报' },
        docName: { vi: 'Tên tài liệu', en: 'Document name', zh: '文档名称' },
        type: { vi: 'Loại', en: 'Type', zh: '类型' },
        updatedAt: { vi: 'Ngày cập nhật', en: 'Updated date', zh: '更新日期' },
        status: { vi: 'Trạng thái', en: 'Status', zh: '状态' },
        actions: { vi: 'Thao tác', en: 'Actions', zh: '操作' },
        selectFile: { vi: 'Chọn file', en: 'Select file', zh: '选择文件' },
        noFileSelected: { vi: 'Không có tệp nào được chọn', en: 'No file selected', zh: '尚未选择文件' },
        editFileHint: { vi: 'Khi chỉnh sửa, file không đổi. Muốn đổi file vui lòng tạo mới hồ sơ.', en: 'When editing, file is not changed. To replace file, create a new document.', zh: '编辑时不会替换文件；若要更换请新建文档。' },
        edit: { vi: 'Chỉnh sửa', en: 'Edit', zh: '编辑' },
        delete: { vi: 'Xóa', en: 'Delete', zh: '删除' },
        view: { vi: 'Xem', en: 'View', zh: '查看' },
        download: { vi: 'Tải xuống', en: 'Download', zh: '下载' },
      },
      docTypes: { legal: { vi: 'Tài liệu pháp lý', en: 'Legal document', zh: '证照' }, certificate: { vi: 'Chứng chỉ', en: 'Certificate', zh: '证书' }, other: { vi: 'Khác', en: 'Other', zh: '其他' } },
      statusOptions: { effective: { vi: 'Có hiệu lực', en: 'In effect', zh: '有效' }, expired: { vi: 'Hết hiệu lực', en: 'Expired', zh: '已过期' }, updating: { vi: 'Đang cập nhật', en: 'Updating', zh: '更新中' } },
      emptyLegal: { vi: 'Chưa có hồ sơ pháp lý.', en: 'No legal documents yet.', zh: '暂无证照档案。' },
      docDialog: {
        createTitle: { vi: 'Tải lên hồ sơ pháp lý', en: 'Upload legal document', zh: '上传证照' },
        editTitle: { vi: 'Cập nhật hồ sơ pháp lý', en: 'Update legal document', zh: '更新证照' },
      },
      messages: {
        loadError: { vi: 'Có lỗi xảy ra khi tải dữ liệu', en: 'An error occurred while loading data', zh: '加载数据时出错' },
        loadInfoError: { vi: 'Có lỗi xảy ra khi tải thông tin đơn vị', en: 'An error occurred while loading unit information', zh: '加载单位信息时出错' },
        saveError: { vi: 'Có lỗi xảy ra khi lưu dữ liệu', en: 'An error occurred while saving data', zh: '保存数据时出错' },
        saveUnitFirst: { vi: 'Cần lưu thông tin đơn vị trước khi thêm hồ sơ pháp lý.', en: 'Save unit information before adding legal documents.', zh: '请先保存单位信息再添加证照。' },
        selectFileRequired: { vi: 'Vui lòng chọn file để tải lên.', en: 'Please select a file to upload.', zh: '请选择要上传的文件。' },
        saveDocError: { vi: 'Có lỗi xảy ra khi lưu hồ sơ pháp lý', en: 'An error occurred while saving legal document', zh: '保存证照时出错' },
        deleteDocConfirm: { vi: 'Bạn có chắc chắn muốn xóa hồ sơ "{{name}}"?', en: 'Are you sure you want to delete document "{{name}}"?' , zh: '确定要删除文档「{{name}}」吗？' },
        deleteDocError: { vi: 'Có lỗi xảy ra khi xóa hồ sơ pháp lý', en: 'An error occurred while deleting legal document', zh: '删除证照时出错' },
      },
    },
    soVanBan: {
      title: { vi: 'Quản lý sổ văn bản', en: 'Document register management', zh: '文书登记管理' },
      subtitle: { vi: 'Thiết lập và quản trị danh mục sổ văn bản theo nhu cầu đơn vị.', en: 'Set up and manage document register catalog for your unit.', zh: '按单位需求设置和管理文书登记目录。' },
      searchPlaceholder: { vi: 'Tìm theo tên hoặc ký hiệu', en: 'Search by name or prefix', zh: '按名称或文号搜索' },
      buttons: { addNew: { vi: 'Thêm mới', en: 'Add new', zh: '添加' }, cancel: { vi: 'Hủy', en: 'Cancel', zh: '取消' }, create: { vi: 'Tạo mới', en: 'Create', zh: '创建' }, update: { vi: 'Cập nhật', en: 'Update', zh: '更新' } },
      cardTitle: { vi: 'Danh mục sổ văn bản', en: 'Document register catalog', zh: '文书登记目录' },
      table: {
        type: { vi: 'Loại', en: 'Type', zh: '类型' },
        name: { vi: 'Tên sổ', en: 'Register name', zh: '登记簿名称' },
        prefix: { vi: 'Ký hiệu', en: 'Prefix', zh: '文号' },
        suffix: { vi: 'Hậu tố', en: 'Suffix', zh: '后缀' },
        startNumber: { vi: 'Số bắt đầu', en: 'Start number', zh: '起始编号' },
        numberNow: { vi: 'Số hiện tại', en: 'Current number', zh: '当前编号' },
        order: { vi: 'Thứ tự', en: 'Order', zh: '顺序' },
        applyTime: { vi: 'Thời gian áp dụng', en: 'Effective period', zh: '生效期' },
        status: { vi: 'Trạng thái', en: 'Status', zh: '状态' },
        sortSymbols: { vi: 'Thứ tự ký hiệu', en: 'Symbol order', zh: '符号顺序' },
        actions: { vi: 'Thao tác', en: 'Actions', zh: '操作' },
      },
      typeIncoming: { vi: 'Văn bản đến', en: 'Incoming', zh: '收文' },
      typeOutgoing: { vi: 'Văn bản đi', en: 'Outgoing', zh: '发文' },
      statusActive: { vi: 'Kích hoạt', en: 'Active', zh: '启用' },
      statusPaused: { vi: 'Tạm dừng', en: 'Paused', zh: '暂停' },
      noData: { vi: 'Không có dữ liệu', en: 'No data', zh: '暂无数据' },
      rowsPerPage: { vi: 'Số dòng', en: 'Rows per page', zh: '每页行数' },
      tooltipUpdate: { vi: 'Cập nhật', en: 'Update', zh: '更新' },
      tooltipDelete: { vi: 'Xóa', en: 'Delete', zh: '删除' },
      dialog: {
        createTitle: { vi: 'Thêm sổ văn bản', en: 'Add document register', zh: '添加文书登记簿' },
        editTitle: { vi: 'Cập nhật sổ văn bản', en: 'Update document register', zh: '更新文书登记簿' },
        typeLabel: { vi: 'Loại sổ văn bản', en: 'Register type', zh: '登记簿类型' },
        nameLabel: { vi: 'Tên sổ văn bản', en: 'Register name', zh: '登记簿名称' },
        namePlaceholder: { vi: 'Nhập tên sổ văn bản', en: 'Enter register name', zh: '输入登记簿名称' },
        prefixLabel: { vi: 'Ký hiệu', en: 'Prefix', zh: '文号' },
        prefixPlaceholder: { vi: 'VD: SVB-2025', en: 'e.g. SVB-2025', zh: '例如：SVB-2025' },
        suffixLabel: { vi: 'Hậu tố', en: 'Suffix', zh: '后缀' },
        suffixPlaceholder: { vi: 'VD: Ban QLDA', en: 'e.g. PMU', zh: '例如：PMU' },
        startNumberLabel: { vi: 'Số bắt đầu', en: 'Start number', zh: '起始编号' },
        numberNowLabel: { vi: 'Số hiện tại', en: 'Current number', zh: '当前编号' },
        sortSymbolOrderLabel: { vi: 'Thứ tự hiển thị', en: 'Display order', zh: '显示顺序' },
        orderLabel: { vi: 'Thứ tự', en: 'Order', zh: '顺序' },
        startDateLabel: { vi: 'Ngày áp dụng', en: 'Effective date', zh: '生效日期' },
        endDateLabel: { vi: 'Ngày kết thúc', en: 'End date', zh: '截止日期' },
        catalogIdsLabel: { vi: 'Danh mục văn bản (ID)', en: 'Document catalog (IDs)', zh: '文档目录 (ID)' },
        catalogPlaceholder: { vi: 'VD: 1, 2, 5', en: 'e.g. 1, 2, 5', zh: '例如：1, 2, 5' },
        statusLabel: { vi: 'Trạng thái', en: 'Status', zh: '状态' },
      },
      validation: {
        nameRequired: { vi: 'Tên sổ văn bản là bắt buộc', en: 'Register name is required', zh: '登记簿名称为必填' },
        startNumberMin: { vi: 'Số bắt đầu phải >= 1', en: 'Start number must be >= 1', zh: '起始编号须 ≥ 1' },
        numberNowMin: { vi: 'Số hiện tại không được nhỏ hơn (số bắt đầu - 1)', en: 'Current number cannot be less than (start number - 1)', zh: '当前编号不能小于（起始编号 - 1）' },
        endDateAfter: { vi: 'Ngày kết thúc phải sau ngày áp dụng', en: 'End date must be after effective date', zh: '截止日期须在生效日期之后' },
      },
      messages: {
        loadError: { vi: 'Có lỗi xảy ra khi tải dữ liệu', en: 'An error occurred while loading data', zh: '加载数据时出错' },
        saveError: { vi: 'Có lỗi xảy ra khi lưu dữ liệu', en: 'An error occurred while saving data', zh: '保存数据时出错' },
        deleteConfirm: { vi: 'Bạn có chắc chắn muốn xóa sổ văn bản "{{name}}"?', en: 'Are you sure you want to delete register "{{name}}"?' , zh: '确定要删除登记簿「{{name}}」吗？' },
        deleteError: { vi: 'Có lỗi xảy ra khi xóa sổ văn bản', en: 'An error occurred while deleting register', zh: '删除登记簿时出错' },
      },
    },
    permissionsPage: {
      title: { vi: 'Phân quyền vai trò', en: 'Role permissions', zh: '角色权限' },
      subtitle: {
        vi: 'Thiết lập quyền truy cập cho từng vai trò trong hệ thống.',
        en: 'Configure access permissions for each role in the system.',
        zh: '为系统中的每个角色配置访问权限。',
      },
      projectLabel: { vi: 'Dự án áp dụng', en: 'Apply to project', zh: '适用项目' },
      projectOption: {
        vi: 'Dự án Metro Line 3 - Gói thầu CPO4',
        en: 'Metro Line 3 - Package CPO4',
        zh: '地铁 3 号线 - CPO4 标段',
      },
      buttons: {
        cancel: { vi: 'Hủy', en: 'Cancel', zh: '取消' },
        save: { vi: 'Lưu thay đổi', en: 'Save changes', zh: '保存更改' },
      },
      roleListTitle: { vi: 'Danh sách vai trò', en: 'Role list', zh: '角色列表' },
      roles: {
        admin: { vi: 'Admin (Quản trị)', en: 'Admin', zh: '管理员' },
        qa: { vi: 'QA/QC', en: 'QA/QC', zh: '质量管理' },
        field: { vi: 'Kỹ sư hiện trường', en: 'Field engineer', zh: '现场工程师' },
        doc: { vi: 'Chuyên viên hồ sơ', en: 'Document specialist', zh: '文档专员' },
        accountant: { vi: 'Kế toán / Thanh toán', en: 'Accounting / Payment', zh: '会计/结算' },
        guest: { vi: 'Người xem (Guest)', en: 'Guest viewer', zh: '访客查看' },
      },
      matrixTitle: { vi: 'Ma trận quyền hạn: Admin', en: 'Permission matrix: Admin', zh: '权限矩阵：管理员' },
      matrixDesc: {
        vi: 'Thiết lập các hành động được phép cho vai trò Admin',
        en: 'Configure allowed actions for Admin role',
        zh: '为管理员角色配置允许的操作。',
      },
      table: {
        feature: { vi: 'Tính năng', en: 'Feature', zh: '功能' },
        view: { vi: 'Xem', en: 'View', zh: '查看' },
        add: { vi: 'Thêm', en: 'Add', zh: '新增' },
        edit: { vi: 'Sửa', en: 'Edit', zh: '编辑' },
        delete: { vi: 'Xóa', en: 'Delete', zh: '删除' },
        approve: { vi: 'Phê duyệt', en: 'Approve', zh: '审批' },
      },
      features: {
        taskManage: { vi: 'Quản lý công việc', en: 'Task management', zh: '任务管理' },
        assetManage: { vi: 'Quản lý tài sản', en: 'Asset management', zh: '资产管理' },
        report: { vi: 'Báo cáo hệ thống', en: 'System reports', zh: '系统报表' },
        legalProfile: { vi: 'Quản lý hồ sơ pháp lý', en: 'Legal document management', zh: '法律档案管理' },
        personnel: { vi: 'Quản lý nhân sự dự án', en: 'Project personnel management', zh: '项目人事管理' },
      },
      note: { vi: 'Lưu ý:', en: 'Note:', zh: '注意：' },
      noteText: { vi: 'Quyền "Phê duyệt" cho phép người dùng thay đổi trạng thái của các tài liệu và quy trình từ \'Chờ duyệt\' sang \'Đã duyệt\'. Chỉ nên cấp quyền này cho các vai trò quản lý hoặc trưởng bộ phận.', en: 'The "Approve" permission allows users to change document/process status from \'Pending\' to \'Approved\'. Grant this only to managers or department heads.', zh: '“审批”权限允许用户将文档/流程状态从“待审批”改为“已审批”。仅应授予管理员或部门负责人。' },
    },
  },
  twoFA: {
    selectMethodDescription: {
      vi: 'Chọn phương thức xác thực 2 bước để tiếp tục.',
      en: 'Choose a two-factor authentication method to continue.',
      zh: '请选择两步验证方式以继续。',
    },
    methods: {
      totpTitle: {
        vi: 'Xác thực bằng TOTP',
        en: 'Verify with TOTP',
        zh: '使用 TOTP 验证',
      },
      totpSubtitle: {
        vi: 'Ứng dụng Authenticator',
        en: 'Authenticator app',
        zh: '验证器应用',
      },
      mailTitle: {
        vi: 'Xác thực bằng Mail OTP',
        en: 'Verify with Mail OTP',
        zh: '使用邮件 OTP 验证',
      },
      mailSubtitle: {
        vi: 'Mã OTP gửi về email',
        en: 'OTP code sent to your email',
        zh: 'OTP 码已发送到您的邮箱',
      },
    },
    enterCodeTitle: {
      vi: 'Nhập mã xác thực',
      en: 'Enter verification code',
      zh: '输入验证码',
    },
    mailCodeDescription: {
      vi: 'Mã xác thực đã gửi đến:',
      en: 'Verification code has been sent to:',
      zh: '验证码已发送至：',
    },
    mailCodeEmailFallback: {
      vi: 'email của bạn',
      en: 'your email',
      zh: '您的邮箱',
    },
    totpCodeDescription: {
      vi: 'Nhập mã 6 số từ ứng dụng Google Authenticator.',
      en: 'Enter the 6-digit code from your Google Authenticator app.',
      zh: '请输入 Google 验证器应用中的 6 位验证码。',
    },
    codeRequired: {
      vi: 'Vui lòng nhập đủ 6 số.',
      en: 'Please enter all 6 digits.',
      zh: '请输入全部 6 位数字。',
    },
    resend: {
      loading: {
        vi: 'Đang gửi...',
        en: 'Sending...',
        zh: '发送中...',
      },
      button: {
        vi: 'Gửi lại mã',
        en: 'Resend code',
        zh: '重新发送',
      },
      failed: {
        vi: 'Gửi lại mã thất bại.',
        en: 'Failed to resend code.',
        zh: '重新发送失败。',
      },
    },
  },
  changePassword: {
    back: {
      vi: 'Quay lại',
      en: 'Back',
      zh: '返回',
    },
    title: {
      vi: 'Đặt lại mật khẩu',
      en: 'Reset password',
      zh: '重置密码',
    },
    description: {
      vi: 'Nhập mật khẩu mới và xác nhận. Mật khẩu cần đáp ứng yêu cầu bảo mật (ít nhất 8 ký tự, chữ hoa, chữ thường, số, ký tự đặc biệt).',
      en: 'Enter a new password and confirmation. The password must meet security requirements (at least 8 characters including uppercase, lowercase, numbers, and special characters).',
      zh: '请输入新密码并确认。密码须符合安全要求（至少8位，含大小写、数字及特殊字符）。',
    },
    newPasswordLabel: {
      vi: 'Mật khẩu mới',
      en: 'New password',
      zh: '新密码',
    },
    newPasswordPlaceholder: {
      vi: 'Nhập mật khẩu mới',
      en: 'Enter new password',
      zh: '输入新密码',
    },
    confirmPasswordLabel: {
      vi: 'Xác nhận mật khẩu',
      en: 'Confirm password',
      zh: '确认密码',
    },
    confirmPasswordPlaceholder: {
      vi: 'Nhập lại mật khẩu mới',
      en: 'Re-enter new password',
      zh: '再次输入新密码',
    },
    submitButton: {
      vi: 'Đặt lại mật khẩu',
      en: 'Reset password',
      zh: '重置密码',
    },
    submitTwoFaButton: {
      vi: 'Xác nhận đổi mật khẩu',
      en: 'Confirm password change',
      zh: '确认修改密码',
    },
    errors: {
      requiredPassword: {
        vi: 'Vui lòng nhập mật khẩu mới.',
        en: 'Please enter a new password.',
        zh: '请输入新密码。',
      },
      requiredConfirmPassword: {
        vi: 'Vui lòng nhập xác nhận mật khẩu.',
        en: 'Please confirm your password.',
        zh: '请再次输入密码以确认。',
      },
      passwordNotMatch: {
        vi: 'Mật khẩu xác nhận không khớp.',
        en: 'Password confirmation does not match.',
        zh: '两次输入的密码不一致。',
      },
      missingUsername: {
        vi: 'Không lấy được thông tin đăng nhập.',
        en: 'Cannot get login information.',
        zh: '无法获取登录信息。',
      },
      changeFailed: {
        vi: 'Đổi mật khẩu thất bại.',
        en: 'Password change failed.',
        zh: '修改密码失败。',
      },
    },
    successTitle: {
      vi: 'Đổi mật khẩu thành công',
      en: 'Password changed successfully',
      zh: '密码已修改',
    },
    successDescription: {
      vi: 'Bạn có thể sử dụng mật khẩu mới cho lần đăng nhập sau.',
      en: 'You can use the new password for your next login.',
      zh: '下次登录可使用新密码。',
    },
    successBackToSettings: {
      vi: 'Quay lại Cài đặt',
      en: 'Back to Settings',
      zh: '返回设置',
    },
  },
  chat: {
    searchPlaceholder: {
      vi: 'Tìm kiếm cuộc trò chuyện...',
      en: 'Search conversations...',
      zh: '搜索会话…',
    },
    structureSectionTitle: {
      vi: 'Phân loại cấu trúc',
      en: 'Structure categories',
      zh: '结构分类',
    },
    personalSectionTitle: {
      vi: 'Cá nhân & khác',
      en: 'Personal & others',
      zh: '个人与其他',
    },
    samplePersonalName: {
      vi: 'Trần Hoàng Nam (Dev)',
      en: 'Tran Hoang Nam (Dev)',
      zh: '陈黄南 (Dev)',
    },
    samplePersonalSubtitle: {
      vi: 'Sẽ gửi file báo cáo vào chiều nay.',
      en: 'Will send the report file this afternoon.',
      zh: '今天下午会发送报告文件。',
    },
    todayChip: {
      vi: 'Hôm nay',
      en: 'Today',
      zh: '今天',
    },
    defaultUser: {
      vi: 'Người dùng',
      en: 'User',
      zh: '用户',
    },
    meLabel: {
      vi: 'Bạn',
      en: 'You',
      zh: '你',
    },
    chooseRoomPlaceholder: {
      vi: 'Chọn phòng chat',
      en: 'Select a chat room',
      zh: '请选择聊天房间',
    },
    phaseLabel: {
      vi: 'Giai đoạn',
      en: 'Phase',
      zh: '阶段',
    },
    taskCodeLabel: {
      vi: 'Mã nhiệm vụ',
      en: 'Task code',
      zh: '任务编号',
    },
    contextInfoTitle: {
      vi: 'Thông tin ngữ cảnh',
      en: 'Context information',
      zh: '上下文信息',
    },
    loading: {
      vi: 'Đang tải...',
      en: 'Loading...',
      zh: '加载中…',
    },
    phaseFieldLabel: {
      vi: 'Giai đoạn',
      en: 'Phase',
      zh: '阶段',
    },
    wbsCodeLabel: {
      vi: 'Mã WBS',
      en: 'WBS code',
      zh: 'WBS 编码',
    },
    ownerLabel: {
      vi: 'Người phụ trách',
      en: 'Owner',
      zh: '负责人',
    },
    membersTitle: {
      vi: 'Thành viên',
      en: 'Members',
      zh: '成员',
    },
    noMembers: {
      vi: 'Chưa có ai tham gia chat',
      en: 'No participants yet',
      zh: '暂时没有参与者',
    },
    filesTitle: {
      vi: 'Tệp liên quan',
      en: 'Related files',
      zh: '相关文件',
    },
    noFiles: {
      vi: 'Chưa có tệp',
      en: 'No files',
      zh: '暂无文件',
    },
    systemRevokedPlaceholder: {
      vi: '[Đã thu hồi]',
      en: '[Revoked]',
      zh: '[已撤回]',
    },
    messageMenu: {
      revoke: {
        vi: 'Thu hồi',
        en: 'Revoke',
        zh: '撤回',
      },
      revokeTooltip: {
        vi: 'Thu hồi tin nhắn (chỉ mình bạn mới thu hồi được, trong vòng 1 tiếng)',
        en: 'Revoke message (only you can revoke within 1 hour)',
        zh: '撤回消息（仅限本人，1 小时内可撤回）',
      },
    },
    pendingFilesHint: {
      vi: 'Có thể nhập tin nhắn rồi bấm Gửi, hoặc bấm Gửi để chỉ gửi file.',
      en: 'You can type a message then click Send, or click Send to send files only.',
      zh: '可输入消息后点击发送，或直接点击发送仅发送文件。',
    },
    filesOnlyPlaceholder: {
      vi: '(file đính kèm)',
      en: '(attachment)',
      zh: '（附件）',
    },
    attachFileTooltip: {
      vi: 'Đính kèm file',
      en: 'Attach file',
      zh: '添加附件',
    },
    inputPlaceholder: {
      vi: 'Nhập tin nhắn gắn kèm mã WBS/ABS...',
      en: 'Type a message, including WBS/ABS code...',
      zh: '输入消息，可包含 WBS/ABS 编码…',
    },
    structureBadgeFallback: {
      vi: 'Cấu trúc công việc',
      en: 'Work structure',
      zh: '工作结构',
    },
    leaveGroup: {
      vi: 'Rời khỏi nhóm',
      en: 'Leave group',
      zh: '退出群组',
    },
  },
  incomingList: {
    titles: {
      default: {
        vi: 'Danh sách văn bản đến',
        en: 'Incoming documents list',
        zh: '来文列表',
      },
      dienTu: {
        vi: 'Danh sách văn bản điện tử',
        en: 'Electronic incoming documents list',
        zh: '电子来文列表',
      },
      duThao: {
        vi: 'Danh sách văn bản dự thảo',
        en: 'Draft incoming documents list',
        zh: '草稿来文列表',
      },
    },
    subtitles: {
      default: {
        vi: 'Quản lý và theo dõi các văn bản đến từ các đơn vị khác.',
        en: 'Manage and track incoming documents from other units.',
        zh: '管理和跟踪来自其他单位的来文。',
      },
      dienTu: {
        vi: 'Văn bản điện tử chưa có sổ, chưa có số, chưa có trạng thái.',
        en: 'Electronic documents without registry, number, or status yet.',
        zh: '尚未登记、编号或设置状态的电子文档。',
      },
      duThao: {
        vi: 'Văn bản đã có sổ, có số nhưng chưa chuyển cho người khác.',
        en: 'Documents already registered and numbered but not yet forwarded to others.',
        zh: '已登记并编号，但尚未转交他人的文档。',
      },
    },
    createButtons: {
      dienTu: {
        vi: 'Nhập mới',
        en: 'New entry',
        zh: '新增',
      },
      default: {
        vi: 'Tạo mới',
        en: 'Create',
        zh: '新建',
      },
    },
    filters: {
      keywordLabel: {
        vi: 'Từ khóa',
        en: 'Keyword',
        zh: '关键字',
      },
      keywordPlaceholder: {
        vi: 'Số ký hiệu, trích yếu...',
        en: 'Number, summary...',
        zh: '文号、摘要…',
      },
      senderLabel: {
        vi: 'Nơi gửi',
        en: 'Sender',
        zh: '来文单位',
      },
      senderPlaceholder: {
        vi: 'Lọc theo nơi gửi...',
        en: 'Filter by sender...',
        zh: '按来文单位筛选…',
      },
      groupLabel: {
        vi: 'Nhóm văn bản',
        en: 'Document group',
        zh: '文档分组',
      },
      groupAllOption: {
        vi: 'Tất cả',
        en: 'All',
        zh: '全部',
      },
      statusLabel: {
        vi: 'Trạng thái',
        en: 'Status',
        zh: '状态',
      },
      statusAllOption: {
        vi: 'Tất cả',
        en: 'All',
        zh: '全部',
      },
      statusOptions: {
        choXuLy: {
          vi: 'Chờ xử lý',
          en: 'Pending',
          zh: '待处理',
        },
        dangXemXet: {
          vi: 'Đang xem xét',
          en: 'Under review',
          zh: '审核中',
        },
        hoanThanh: {
          vi: 'Hoàn thành',
          en: 'Completed',
          zh: '已完成',
        },
        quaHan: {
          vi: 'Quá hạn',
          en: 'Overdue',
          zh: '已逾期',
        },
        traLai: {
          vi: 'Trả lại',
          en: 'Returned',
          zh: '已退回',
        },
      },
      searchButton: {
        vi: 'Tìm kiếm',
        en: 'Search',
        zh: '搜索',
      },
      filterTooltip: {
        vi: 'Bộ lọc',
        en: 'Filters',
        zh: '筛选',
      },
    },
    table: {
      columns: {
        documentCode: {
          vi: 'Số ký hiệu',
          en: 'Doc Num',
          zh: '文号',
        },
        summary: {
          vi: 'Trích yếu nội dung',
          en: 'Summary',
          zh: '摘要',
        },
        receivedDate: {
          vi: 'Ngày đến',
          en: 'Received date',
          zh: '收文日期',
        },
        handler: {
          vi: 'Người xử lý',
          en: 'Handler',
          zh: '办理人',
        },
        role: {
          vi: 'Vai trò',
          en: 'Role',
          zh: '角色',
        },
        priority: {
          vi: 'Độ khẩn',
          en: 'Priority',
          zh: '紧急程度',
        },
        unit: {
          vi: 'Đơn vị VB',
          en: 'Document unit',
          zh: '文档单位',
        },
      },
      empty: {
        vi: 'Chưa có văn bản nào.',
        en: 'No documents yet.',
        zh: '暂无文档。',
      },
      paginationSummary: {
        vi: (from: number, to: number, total: number) =>
          `Hiển thị ${from}-${to} trong tổng số ${total} văn bản`,
        en: (from: number, to: number, total: number) =>
          `Showing ${from}-${to} of ${total} documents`,
        zh: (from: number, to: number, total: number) =>
          `显示第 ${from}-${to} 条，共 ${total} 份文档`,
      },
    },
    dialog: {
      createTitleDefault: {
        vi: 'Tạo mới văn bản đến',
        en: 'Create new incoming document',
        zh: '新建来文',
      },
      createTitleDienTu: {
        vi: 'Tạo mới văn bản điện tử',
        en: 'Create new electronic document',
        zh: '新建电子来文',
      },
      createTitleDuThao: {
        vi: 'Tạo mới văn bản dự thảo',
        en: 'Create new draft incoming document',
        zh: '新建来文草稿',
      },
      errors: {
        attachmentsRequired: {
          vi: 'Vui lòng đính kèm ít nhất một file',
          en: 'Please attach at least one file',
          zh: '请至少附加一个文件',
        },
        documentCodeRequiredShort: {
          vi: 'Số ký hiệu là bắt buộc',
          en: 'Document number is required',
          zh: '文号为必填项',
        },
        documentCodeRequiredSnackbar: {
          vi: 'Vui lòng nhập số ký hiệu',
          en: 'Please enter the document number',
          zh: '请输入文号',
        },
        docsGroupRequiredDraftShort: {
          vi: 'Sổ văn bản là bắt buộc khi tạo dự thảo',
          en: 'Document registry is required when creating a draft',
          zh: '创建草稿时必须选择文档登记簿',
        },
        docsGroupRequiredDraftSnackbar: {
          vi: 'Vui lòng chọn sổ văn bản',
          en: 'Please select a document registry',
          zh: '请选择文档登记簿',
        },
        createFailed: {
          vi: 'Tạo văn bản thất bại',
          en: 'Failed to create document',
          zh: '创建文档失败',
        },
        createErrorGeneric: {
          vi: 'Có lỗi xảy ra khi tạo văn bản',
          en: 'An error occurred while creating the document',
          zh: '创建文档时发生错误',
        },
      },
      attachmentsTitle: {
        vi: 'File đính kèm',
        en: 'Attachments',
        zh: '附件',
      },
      attachmentsRequiredShort: {
        vi: '(bắt buộc)',
        en: '(required)',
        zh: '（必填）',
      },
      actions: {
        cancel: {
          vi: 'Hủy',
          en: 'Cancel',
          zh: '取消',
        },
        submit: {
          vi: 'Tạo văn bản',
          en: 'Create document',
          zh: '创建文档',
        },
      },
    },
    actionNeeded: {
      xulyChinh: {
        vi: 'Xử lý chính',
        en: 'Main handler',
        zh: '主办',
      },
      xulyPhoiHop: {
        vi: 'Phối hợp',
        en: 'Co-processing',
        zh: '协办',
      },
      xemDeBiet: {
        vi: 'Xem để biết',
        en: 'For information',
        zh: '知会',
      },
      trinhLdBophan: {
        vi: 'Trình LĐ bộ phận',
        en: 'Submit to department leader',
        zh: '呈送部门领导',
      },
      trinhLdDonvi: {
        vi: 'Trình LĐ đơn vị',
        en: 'Submit to unit leader',
        zh: '呈送单位领导',
      },
      chuyenXuLy: {
        vi: 'Chuyển xử lý',
        en: 'Forward for processing',
        zh: '转交处理',
      },
      choXuLy: {
        vi: 'Chờ xử lý',
        en: 'Pending',
        zh: '待处理',
      },
    },
    menu: {
      viewDetail: {
        vi: 'Xem chi tiết',
        en: 'View detail',
        zh: '查看详情',
      },
      submitLeader: {
        vi: 'Trình lãnh đạo',
        en: 'Submit to leader',
        zh: '呈送领导',
      },
      forward: {
        vi: 'Chuyển xử lý',
        en: 'Forward for processing',
        zh: '转交处理',
      },
      archive: {
        vi: 'Lưu trữ',
        en: 'Archive',
        zh: '归档',
      },
      close: {
        vi: 'Kết thúc',
        en: 'Close',
        zh: '结束',
      },
      takeBack: {
        vi: 'Lấy lại',
        en: 'Take back',
        zh: '取回',
      },
    },
    messages: {
      genericError: {
        vi: 'Có lỗi xảy ra khi xử lý yêu cầu',
        en: 'An error occurred while processing the request',
        zh: '处理请求时发生错误',
      },
    },
  },
  outgoingList: {
    title: {
      vi: 'Danh sách văn bản đi',
      en: 'Outgoing documents list',
      zh: '发文列表',
    },
    subtitle: {
      vi: 'Quản lý và theo dõi các văn bản đi đã được ban hành.',
      en: 'Manage and track issued outgoing documents.',
      zh: '管理和跟踪已发出的文档。',
    },
    createButton: {
      vi: 'Tạo văn bản đi',
      en: 'Create',
      zh: '新建发文',
    },
    listTypeFilterLabel: {
      vi: 'Loại danh sách',
      en: 'List type',
      zh: '列表类型',
    },
    filters: {
      keywordLabel: {
        vi: 'Tìm kiếm',
        en: 'Search',
        zh: '搜索',
      },
      keywordPlaceholder: {
        vi: 'Số hiệu, trích yếu, người gửi...',
        en: 'Number, summary, sender...',
        zh: '文号、摘要、发件人…',
      },
      documentDateLabel: {
        vi: 'Ngày văn bản',
        en: 'Document date',
        zh: '文档日期',
      },
      groupLabel: {
        vi: 'Nhóm sổ văn bản',
        en: 'Document book group',
        zh: '文书簿组',
      },
      groupAllOption: {
        vi: 'Tất cả',
        en: 'All',
        zh: '全部',
      },
      statusLabel: {
        vi: 'Trạng thái',
        en: 'Status',
        zh: '状态',
      },
      statusOptions: {
        all: {
          vi: 'Tất cả',
          en: 'All',
          zh: '全部',
        },
        moiKhoiTao: {
          vi: 'Mới khởi tạo',
          en: 'Newly created',
          zh: '新建',
        },
        trinhLdBophan: {
          vi: 'Trình LĐ bộ phận',
          en: 'Submitted to department leader',
          zh: '呈送部门领导',
        },
        trinhLdDonvi: {
          vi: 'Trình LĐ đơn vị',
          en: 'Submitted to unit leader',
          zh: '呈送单位领导',
        },
        trinhLdBan: {
          vi: 'Trình LĐ ban',
          en: 'Submitted to board',
          zh: '呈送委员会',
        },
        daDuyet: {
          vi: 'Đã duyệt',
          en: 'Approved',
          zh: '已批准',
        },
        daBanHanh: {
          vi: 'Đã ban hành',
          en: 'Issued',
          zh: '已发布',
        },
        tuChoi: {
          vi: 'Từ chối',
          en: 'Rejected',
          zh: '已拒绝',
        },
        huy: {
          vi: 'Hủy',
          en: 'Cancelled',
          zh: '已取消',
        },
      },
      searchButton: {
        vi: 'Tìm kiếm',
        en: 'Search',
        zh: '搜索',
      },
      advancedFilterTooltip: {
        vi: 'Bộ lọc nâng cao',
        en: 'Advanced filters',
        zh: '高级筛选',
      },
    },
    bulkActions: {
      viewOnly: {
        vi: 'Chuyển xem để biết',
        en: 'Forward for information',
        zh: '转发以供知会',
      },
    },
    table: {
      columns: {
        documentCode: {
          vi: 'Số ký hiệu',
          en: 'Doc Num',
          zh: '文号',
        },
        title: {
          vi: 'Trích yếu nội dung',
          en: 'Summary',
          zh: '摘要',
        },
        unit: {
          vi: 'Đơn vị VB',
          en: 'Document unit',
          zh: '文档单位',
        },
        catalogName: {
          vi: 'Loại văn bản',
          en: 'Document type',
          zh: '文档类型',
        },
        documentDate: {
          vi: 'Ngày VB',
          en: 'Document date',
          zh: '文档日期',
        },
        createdBy: {
          vi: 'Người tạo',
          en: 'Created by',
          zh: '创建人',
        },
        status: {
          vi: 'Trạng thái',
          en: 'Status',
          zh: '状态',
        },
      },
      sentByPrefix: {
        vi: 'Gửi:',
        en: 'From:',
        zh: '发件人：',
      },
      empty: {
        vi: 'Không có văn bản nào',
        en: 'No documents',
        zh: '暂无文档',
      },
      paginationSummary: {
        vi: (from: number, to: number, total: number) =>
          `Hiển thị ${from}-${to} trong tổng số ${total} văn bản`,
        en: (from: number, to: number, total: number) =>
          `Showing ${from}-${to} of ${total} documents`,
        zh: (from: number, to: number, total: number) =>
          `显示第 ${from}-${to} 条，共 ${total} 份文档`,
      },
    },
    lienThong: {
      buttonLabel: {
        vi: 'Trạng thái liên thông',
        en: 'Interconnection status',
        zh: '互联状态',
      },
      dialogTitle: {
        vi: 'Trạng thái liên thông',
        en: 'Interconnection status',
        zh: '互联状态',
      },
      idIncomingLevel0: {
        vi: 'ID VB đến (cấp 0)',
        en: 'Incoming doc ID (level 0)',
        zh: '收文ID（0级）',
      },
      idIncomingLevel1: {
        vi: 'ID VB đến (cấp 1)',
        en: 'Incoming doc ID (level 1)',
        zh: '收文ID（1级）',
      },
      emptyIntro: {
        vi: 'Quy trình mà đơn vị nhận được xử lý văn bản bạn sẽ hiện ở đây.',
        en: 'The process by which the receiving unit processes your document will be shown here.',
        zh: '接收单位处理您文档的流程将显示在此处。',
      },
      emptyUnitNotProcessed: {
        vi: 'Đơn vị này chưa xử lý văn bản của bạn.',
        en: 'This unit has not yet processed your document.',
        zh: '该单位尚未处理您的文档。',
      },
      processIntro: {
        vi: 'Quy trình xử lý văn bản này sẽ hiển thị ở đây.',
        en: 'The processing flow of this document will be displayed here.',
        zh: '本文档的处理流程将显示在此处。',
      },
      close: {
        vi: 'Đóng',
        en: 'Close',
        zh: '关闭',
      },
      /** Kiểm tra xử lý chính tại VB đến cấp 0 (QLVB): đủ sổ, số, trạng thái */
      xuLyChinhCap0Label: {
        vi: 'Xử lý chính (đơn vị cấp 0)',
        en: 'Main processing (level-0 unit)',
        zh: '主流程（0级单位）',
      },
      xuLyChinhCap0HintOk: {
        vi:
          'Đã có sổ văn bản, số và trạng thái xử lý — không thể thu hồi.',
        en: 'Register, number and status are set — recall is not allowed.',
        zh: '已具备登记簿、编号与处理状态 — 不可撤回。',
      },
      xuLyChinhCap0HintMissing: {
        vi:
          'Chưa đủ sổ văn bản, số hoặc trạng thái xử lý (docs_group_id, docs_group_name, document_number, status) — có thể thu hồi.',
        en: 'Incomplete register/number/status — recall is allowed.',
        zh: '登记簿、编号或处理状态未齐 — 可以撤回。',
      },
      xuLyChinhCap1Label: {
        vi: 'Xử lý chính (đơn vị cấp 1)',
        en: 'Main processing (level-1 unit)',
        zh: '主流程（1级单位）',
      },
      xuLyChinhCap1HintOk: {
        vi: 'Đã có log xử lý của văn bản này — không thể thu hồi.',
        en: 'Processing logs already exist — recall is not allowed.',
        zh: '该文档已有处理日志 — 不可撤回。',
      },
      xuLyChinhCap1HintMissing: {
        vi: 'Chưa có log xử lý trong bảng lịch sử xử lý — có thể thu hồi.',
        en: 'No processing log exists yet — recall is allowed.',
        zh: '处理历史中暂无日志 — 可以撤回。',
      },
      /** API luong-xuly trả code 1 khi VB đến QLVB is_active = 0 (thu hồi / xóa) */
      incomingRevokedOrDeleted: {
        vi: 'Văn bản đã bị thu hồi hoặc đã xóa',
        en: 'This document has been recalled or deleted',
        zh: '该文档已被撤回或删除',
      },
      thuHoiButton: {
        vi: 'Thu hồi',
        en: 'Recall',
        zh: '撤回',
      },
      thuHoiDialogTitle: {
        vi: 'Thu hồi văn bản đến',
        en: 'Recall incoming document',
        zh: '撤回收文',
      },
      thuHoiNoteLabel: {
        vi: 'Ghi chú thu hồi (bắt buộc)',
        en: 'Recall note (required)',
        zh: '撤回备注（必填）',
      },
      thuHoiNotePlaceholder: {
        vi: 'Nhập lý do hoặc nội dung thu hồi…',
        en: 'Enter reason or details…',
        zh: '填写撤回原因或说明…',
      },
      thuHoiNoteRequired: {
        vi: 'Vui lòng nhập ghi chú thu hồi',
        en: 'Please enter a recall note',
        zh: '请填写撤回备注',
      },
      thuHoiDialogConfirm: {
        vi: 'Xác nhận thu hồi',
        en: 'Confirm recall',
        zh: '确认撤回',
      },
      thuHoiDialogCancel: {
        vi: 'Hủy',
        en: 'Cancel',
        zh: '取消',
      },
      thuHoiSuccess: {
        vi: 'Đã thu hồi văn bản đến',
        en: 'Incoming document recalled',
        zh: '已撤回收文',
      },
      thuHoiError: {
        vi: 'Không thu hồi được',
        en: 'Recall failed',
        zh: '撤回失败',
      },
    },
  },
  search: {
    breadcrumbHome: {
      vi: 'Trang chủ',
      en: 'Home',
      zh: '首页',
    },
    breadcrumbSearch: {
      vi: 'Tìm kiếm',
      en: 'Search',
      zh: '搜索',
    },
    pageTitleWithKeyword: {
      vi: (kw: string) => `Kết quả tìm kiếm cho: "${kw}"`,
      en: (kw: string) => `Search results for: "${kw}"`,
      zh: (kw: string) => `“${kw}” 的搜索结果`,
    },
    pageTitleDefault: {
      vi: 'Tìm kiếm tổng quan',
      en: 'Global search',
      zh: '全局搜索',
    },
    subtitleWithKeyword: {
      vi: (total: number) => `Tìm thấy ${total} kết quả phù hợp`,
      en: (total: number) => `Found ${total} matching results`,
      zh: (total: number) => `找到 ${total} 条匹配结果`,
    },
    subtitleDefault: {
      vi: (total: number) => `Tổng quan: ${total} văn bản`,
      en: (total: number) => `Overview: ${total} documents`,
      zh: (total: number) => `概览：共 ${total} 份文档`,
    },
    tabs: {
      allWithCount: {
        vi: (count: number) => `Tất cả (${count})`,
        en: (count: number) => `All (${count})`,
        zh: (count: number) => `全部 (${count})`,
      },
      incomingWithCount: {
        vi: (count: number) => `Văn bản đến (${count})`,
        en: (count: number) => `Incoming (${count})`,
        zh: (count: number) => `来文 (${count})`,
      },
      outgoingWithCount: {
        vi: (count: number) => `Văn bản đi (${count})`,
        en: (count: number) => `Outgoing (${count})`,
        zh: (count: number) => `发文 (${count})`,
      },
    },
    sort: {
      time: {
        vi: 'Thời gian',
        en: 'Time',
        zh: '时间',
      },
      status: {
        vi: 'Trạng thái',
        en: 'Status',
        zh: '状态',
      },
    },
    table: {
      columns: {
        codeAndSummary: {
          vi: 'SỐ HIỆU / TRÍCH YẾU NỘI DUNG',
          en: 'NUMBER / SUMMARY',
          zh: '文号 / 摘要',
        },
        type: {
          vi: 'LOẠI',
          en: 'TYPE',
          zh: '类别',
        },
        list: {
          vi: 'DANH SÁCH',
          en: 'LIST',
          zh: '列表',
        },
        date: {
          vi: 'NGÀY BAN HÀNH/ĐẾN',
          en: 'ISSUED / RECEIVED DATE',
          zh: '签发/收文日期',
        },
        handler: {
          vi: 'NGƯỜI XỬ LÝ',
          en: 'HANDLER',
          zh: '经办人',
        },
        status: {
          vi: 'TRẠNG THÁI',
          en: 'STATUS',
          zh: '状态',
        },
      },
    },
    typeChip: {
      incoming: {
        vi: 'Văn bản đến',
        en: 'Incoming document',
        zh: '来文',
      },
      outgoing: {
        vi: 'Văn bản đi',
        en: 'Outgoing document',
        zh: '发文',
      },
    },
    listLabels: {
      incoming: {
        choXuLy: {
          vi: 'Đến - Chờ xử lý',
          en: 'Incoming - Pending',
          zh: '来文 - 待处理',
        },
        daXuLy: {
          vi: 'Đến - Đã xử lý',
          en: 'Incoming - Processed',
          zh: '来文 - 已处理',
        },
        duThao: {
          vi: 'Đến - Dự thảo',
          en: 'Incoming - Draft',
          zh: '来文 - 草稿',
        },
        dienTu: {
          vi: 'Đến - Điện tử',
          en: 'Incoming - Electronic',
          zh: '来文 - 电子',
        },
      },
      outgoing: {
        choXuLy: {
          vi: 'Đi - Chờ xử lý',
          en: 'Outgoing - Pending',
          zh: '发文 - 待处理',
        },
        daXuLy: {
          vi: 'Đi - Đã xử lý',
          en: 'Outgoing - Processed',
          zh: '发文 - 已处理',
        },
        xemDeBiet: {
          vi: 'Đi - Xem để biết',
          en: 'Outgoing - For information',
          zh: '发文 - 抄送知悉',
        },
      },
    },
    paginationSummary: {
      vi: (from: number, to: number, total: number) =>
        `Hiển thị ${from}-${to} trên ${total} kết quả`,
      en: (from: number, to: number, total: number) =>
        `Showing ${from}-${to} of ${total} results`,
      zh: (from: number, to: number, total: number) =>
        `显示第 ${from}-${to} 条，共 ${total} 条结果`,
    },
  },
  projectTab: {
    title: {
      vi: 'Dự án',
      en: 'Projects',
      zh: '项目',
    },
    subtitle: {
      vi: '(Demo) Nội dung tab Dự án sẽ được bổ sung theo yêu cầu.',
      en: '(Demo) Project tab content will be added as requested.',
      zh: '（演示）项目标签页内容将按需补充。',
    },
  },
  contractTab: {
    title: {
      vi: 'Hợp đồng',
      en: 'Contracts',
      zh: '合同',
    },
    subtitle: {
      vi: '(Demo) Nội dung tab Hợp đồng sẽ được bổ sung theo yêu cầu.',
      en: '(Demo) Contract tab content will be added as requested.',
      zh: '（演示）合同标签页内容将按需补充。',
    },
  },
  // wbsFbs đã được tách sang file language_wbs_fbs.ts
} as const;



